import guida from "./guida.js";

export default {
  it: {
    // Testi delle guide in app: app/i18n/guida.js (GUIDE_REGOLE §7).
    guida,
    causale: "Causale",
    aggiungi_causale: "Aggiungi causale",
    banca_ore_scala: "Scala {ore} dalla banca ore di {nome}.",
    banca_ore_restituisce: "Le {ore} tornano nella banca ore di {nome}.",
    banca_ore_varia: "Dalla banca ore di {nome} si scalano {dopo} invece di {prima}.",
    banca_ore_disponibile: "Disponibile, al netto delle ore già prenotate: {prima} → {dopo}",
    banca_ore_sotto_zero: "Il saldo della banca ore va sotto zero.",
    ore_causali_oltre_totale: "Le ore delle causali superano le ore permesso del giorno.",
    causale_ripetuta: "Una causale può comparire una sola volta nello stesso giorno.",
    causale_ferie_non_ammessa: "Le ferie vanno in «Ore ferie», non fra le causali delle ore permesso.",
    richiesta_non_trovata: "Le ore di questa richiesta non si possono correggere: ricarica la pagina.",
    ore_richiesta_tooltip: "{nome} · richiesto {ore}",
    timbrature: "Timbrature",
    stato_giorni: "Stato giorni",
    giorno_con_problemi: "Giorno da verificare",
    giorno_senza_problemi: "Giorno regolare",
    giorni_con_problemi: "Da verificare",
    giorni_senza_problemi: "Regolari",
    nessun_problema_rilevato: "Nessuna anomalia rilevata",
    problema_pausa_non_timbrata: "Pausa non timbrata",
    problema_segnalazioni: "Segnalazioni da gestire: {n}",
    problema_chiusura_anomala: "Timbratura chiusa in automatico",
    problema_sessione_aperta: "Uscita non timbrata ({n})",
    problema_pausa_aperta: "Fine pausa non timbrata ({n})",
    problema_ritardo: "Ritardo: {ore}",
    problema_permesso_senza_causale: "Permesso senza causale: {ore}",
    problema_assenza_non_giustificata: "Assenza non giustificata (previste {monte})",
    problema_sotto_monte_ore: "Ore sotto il monte ore: {ore} su {monte}",
    categoria_permesso_disattivata: "La categoria selezionata non è abilitata per questa azienda.",
    abilitazione_azienda: "Abilitazione",
    abilitata: "Abilitata",
    disabilitata: "Disabilitata",
    abilita_categoria_per_azienda: "Rendi la categoria richiedibile nell'azienda selezionata",
    disabilita_categoria_per_azienda: "Nascondi la categoria nelle richieste dell'azienda selezionata",
    seleziona_azienda_per_abilitazione: "Seleziona un'azienda per gestire l'abilitazione delle categorie",
    solo_super_admin_abilitazione: "Solo il Super Amministratore può modificare l'abilitazione",
    includi_archiviati: "Includi archiviati",
    archiviato: "Archiviato",
    dipendente_archiviato_sola_lettura: "Dipendente archiviato — sola lettura: presenze consultabili ed esportabili, non modificabili.",
    permesso_dipendente_archiviato: "Il dipendente è archiviato: il permesso è in sola lettura.",
    // Codice d'errore del server (ERRORE_UTENTE_ARCHIVIATO), mostrato con t(response.error).
    utente_archiviato: "Dipendente archiviato: presenze in sola lettura.",
    nessun_messaggio: "Nessun messaggio",
    premi_per_scaricare: "Premi per scaricare",
    non_lavorativo: "Non lavorativo",
    lavorativo: "Lavorativo",
    tooltip_no_mantieni_straordinari: "Le ore di straordinario non verranno convertite nella banca ore e verranno mantenute nel mese",
    tooltip_si_rimuovi_straordinari: "Le ore di straordinario verranno convertite nella banca ore e rimosse dal mese",
    tooltip_si_mantieni_straordinari: "Le ore di straordinario verranno convertite nella banca ore e mantenute nel mese",
    nessuna_nota_admin: "Nessuna nota amministrativa",
    conferma_validazione_mese: "Confermi di voler validare il mese selezionato?",
    conferma_sblocco_mese: "Confermi di voler invalidare il mese selezionato?",
    nessuna_richiesta_ferie_permessi: "Nessuna richiesta di ferie o permessi nel periodo selezionato.",
    nessuna_note_spese: "Nessuna nota spese nel periodo selezionato.",
    note_spese: "Note spese",
    totale_mese: "Totale mese",
    permessi_richiesti: "Permessi richiesti",
    automatico: "Automatico",
    capogruppo_esterno_admin_avviso_titolo: "Il capogruppo esterno selezionato è un amministratore",
    capogruppo_esterno_admin_avviso_descrizione:
      "L'utente selezionato come capogruppo esterno è già un amministratore, quindi non è necessario assegnargli ulteriori permessi, in quanto tutti quelli configurabili per il capogruppo esterno sono già inclusi nei permessi di amministratore.",
    amministratore: "Amministratore",
    configurazioni_gia_attive_essendo_admin:
      "La configurazione dei permessi aggiuntivi non è necessaria essendo l'utente un amministratore, per cui è già dotato dei suddetti permessi.",
    capogruppo_gia_presente: "Non configurabile in quanto è già presente un capogruppo per questo gruppo.",
    gia_attivo_essendo_admin: "Non configurabile in quanto l\'utente è già amministratore, per cui dispone già di questo permesso.",
    pianifica_turni_settimanali: "Pianifica turni settimanali",
    spiegazione_pianifica_turni_settimanali:
      "Se attivi in configurazione aziendale, permetti all'utente in questione di pianificare i turni settimanali per se stesso e per le risorse associate.",
    destinatari_notifiche_impostazioni: "Destinatari notifiche definiti nelle impostazioni",
    notifiche_disattivate: "Notifiche disattivate",
    notifiche_disattivate_descrizione: "Le notifiche sono disattivate per configurazione aziendale.",
    abilita_configurazione_gruppo: "Configurazione gruppo",
    notifiche_usa_default_sistema: "Impostazioni di sistema attive",
    notifiche_usa_default_sistema_descrizione:
      "Le notifiche per questa sezione seguono le impostazioni globali dell'azienda. Attiva il toggle per personalizzare il comportamento delle notifiche per questo gruppo.",
    chi_notificare: "Chi notificare",
    emails_configurate_in_impostazioni: "Email configurate nelle impostazioni",
    spiegazione_notifiche_impostazioni: `
      <p>
        In questa sezione puoi scegliere <strong>chi riceve le notifiche email per ciascun evento</strong> (responsabili e capogruppo).
      </p>

      <p>
      <strong>Se non imposti nulla:</strong><br>
        verranno utilizzate automaticamente le email definite nelle <strong>impostazioni aziendali</strong>.
      </p>

      <p>
      <strong>Se imposti dei destinatari qui:</strong><br>
        queste impostazioni <strong>sostituiscono quelle aziendali</strong>, ma <strong>solo per gli eventi configurati</strong>.
      </p>

      <p>
        <strong>Attenzione:</strong><br>
        queste impostazioni valgono <strong>solo per i membri di questo gruppo</strong>.
      </p>

      <div>
        <ul>
          <li>Gli utenti che appartengono ad altri gruppi seguiranno le impostazioni del loro gruppo (se presenti) oppure quelle aziendali.</li>
          <li>Gli utenti che non appartengono a nessun gruppo seguiranno sempre le impostazioni aziendali.</li>
       </ul>
      </div>
    `,
    email_destinatari_obbligatoria: "Inserisci almeno un indirizzo email valido e se ne inserisci di più tutti devono essere validi.",
    anteprima_area_camera: "Area di anteprima fotocamera",
    anteprima_descrizione: "L'area di anteprima della fotocamera mostra un'anteprima del feed video catturato dalla fotocamera del dispositivo kiosk.",
    spiegazione_intervallo_foto_random:
      "Indica ogni quanto vengono scattate in maniera randomica le fotografie in fase di bollatura da parte del dispositivo kiosk. Ogni X presenze rilevate scatta una foto",
    gestore_todoe: "Gestore ToDo-E",
    sa: "Super Amministratore",
    admin: "Amministratore",
    risorsa: "Risorsa",
    stessa_di_sezione_contatti: "L'email corrisponde con quella presente nella sezione 'Contatti'",
    utenza_sa: "Utenza SA",
    spiegazione_modifica_utenza_sa:
      "Qui puoi modificare i dati (username o password) dell'utenza SA (Super Amministratore) della tua azienda. Questa utenza ha accesso completo a tutte le funzionalità e dati dell'azienda, ed è responsabile della gestione e configurazione iniziale. L'aggiornamento della password avviene solamente quando il funzionamento per l'aggiornamento risulta sbloccato tramite il bottone apposito. Se il funzionamento è bloccato, la password non verrà aggiornata anche se modificata in questo form, e rimarrà valida quella precedente. In caso di aggiornamento dei dati (sia username che password) è caldamente consigliato l'invio delle credenziali via email.",
    spiegazione_creazione_utenza_sa:
      "Qui vengono create le utenze SA (Super Amministratore) della nuova azienda. Ogni utenza avrà accesso completo a tutte le funzionalità e dati dell'azienda, e sarà responsabile della gestione e configurazione iniziale. È possibile creare più Super Admin, ciascuno con la propria email indipendente.",
    spiegazione_modifica_utenza_sa_multipla:
      "Qui puoi gestire le utenze SA (Super Amministratore) della tua azienda. Puoi aggiungere nuovi Super Admin, modificare quelli esistenti o rimuoverli. Ogni SA ha accesso completo a tutte le funzionalità e dati dell'azienda. L'aggiornamento della password avviene solamente quando il funzionamento per l'aggiornamento risulta sbloccato tramite il bottone apposito.",
    aggiungi_super_admin: "Aggiungi Super Admin",
    rimuovi_super_admin: "Rimuovi",
    conferma_rimozione_sa: "Sei sicuro di voler rimuovere questo Super Admin?",
    super_admin_n: "Super Admin #{n}",
    almeno_un_sa_obbligatorio: "Almeno un Super Admin è obbligatorio",
    email_sa: "Email Super Admin",
    ricalcolo_eseguito_con_successo: "Ricalcolo eseguito con successo!",
    dati_non_modificabili: "I dati non possono essere modificati",
    premi_orario_per_modificare: "Premi sull'orario per modificarlo",
    orari_turni_obbligatori_fascia: "Aggiungi almeno una fascia oraria con inizio e fine turno",
    abilitare_almeno_un_giorno_lavorativo: "In modalità Ordinari devi abilitare almeno un giorno lavorativo",
    modalita_orario_obbligatoria: "Modalità orario obbligatoria",
    pausa: "Pausa",
    mensile: "Mensile",
    trimestrale: "Trimestrale",
    semestrale: "Semestrale",
    annuale: "Annuale",
    bollatura_disattiva: "Rilevazione presenze non attiva",
    bollatura_remota_disattiva: "Rilevazione presenze remota non attiva",
    filtra_tipologia_permesso: "Filtra per tipologia permesso",
    aggiorna_e_ricalcola: "Aggiorna e ricalcola",
    aggiorna_e_ricalcola_dai_turni_salvati: "Aggiorna e ricalcola dai turni salvati",
    ricalcola_da_bollature_effettive: "Ricalcola da bollature effettive",
    conferma_ricalcolo_da_bollature_effettive: "Conferma ricalcolo da bollature",
    conferma_ricalcolo_da_bollature_effettive_testo:
      "Gli orari approssimati salvati verranno rigenerati dalle bollature effettive e le modifiche non salvate del dialogo andranno perse.",
    aggiorna_tutto: "Aggiorna tutto",
    aggiorna: "Aggiorna",
    prossimo_rinnovo: "Prossimo rinnovo licenza",
    utenti_licenza: "Utenti licenza",
    utenti_attivi: "Utenti attivi",
    utenti_disponibili: "Utenti disponibili",
    non_autorizzato: "Non autorizzato",
    azione_non_disponibile: "Azione non disponibile",
    nessuno: "Nessuno",
    scala_da_banca_ore: "Scala da banca ore",
    scala_ferie_maturate: "Scala da ferie maturate",
    scala_permessi_maturati: "Scala da permessi maturati",
    tipologia_movimento: "Tipologia movimento",
    strumenti: "Strumenti",
    aggiornamento_in_corso: "Aggiornamento in corso...",
    sto_aggiornando_i_dati_e_il_menu_in_base_alla_nuova_azienda: "Aggiornamento dati e menu in corso in base alla nuova azienda.",
    pausa_retribuita: "Pausa retribuita",
    nessun_turno: "Nessun turno programmato per oggi. Contatta l'amministratore se pensi che sia un errore.",
    gruppo_duplicato: "Gruppo duplicato con successo!",
    reset_filtri: "Reset filtri",
    faq: "FAQ",
    consulta_faq: "Consulta le domande frequenti",
    domande_frequenti: "Domande Frequenti",
    chiudi: "Chiudi",

    faq_1_domanda: "Come creare una nuova note spesa?",
    faq_1_risposta:
      "Clicca il pulsante 'Nuova note spesa' in alto a destra. Compila il form con i dettagli della spesa e invia. La note spesa verrà aggiunta alla lista e potrà essere approvata dal responsabile.",

    faq_2_domanda: "Quali documenti devo allegare?",
    faq_2_risposta_1: "Ricevuta o fattura della spesa",
    faq_2_risposta_2: "Fotografia o scansione del documento",
    faq_2_risposta_3: "I formati accettati sono PDF, JPG, PNG",

    faq_3_domanda: "Come modificare una note spesa in attesa?",
    faq_3_risposta:
      "In tabella dal campo azioni cliccando su Visualizza dettagli è possibile modificare la note spesa. Apporta i cambiamenti necessari e aggiorna. Le note spesa per essere modificate devono essere in stato 'In attesa'.",

    faq_4_domanda: "Cosa significa 'Valida mese'?",
    faq_4_risposta:
      "Per validare il mese le note spesa devono essere tutte approvate e/o rifiutate. Se un mese è validato significa che non è possibile aggiungere, modificare note spesa per quel periodo per quell'utente. Solo l'amministratore può invalidare un mese. Una volta invalidato il mese, è possibile modificare lo stato delle note spesa e successivamente validarlo nuovamente.",

    faq_5_domanda: "Come esportare le note spesa?",
    faq_5_risposta_1: "Una volta validato il mese, è possibile esportare le note spesa in Excel o PDF del singolo utente.",
    descrizione_menu: "Mostra o nasconde il menu laterale.",
    descrizione_aggiungi_preferito: "Aggiungi o rimuovi questa pagina dai preferiti.",
    cambia_tema: "Cambia tema",
    descrizione_cambia_tema: "Cambia il tema dell'interfaccia (chiaro, scuro o automatico).",
    descrizione_cerca: "Cerca rapidamente tra le note spesa per risorsa, motivazione, localita e altri dati visibili.",
    tour_avvia_creazione_nuova_nota_spesa: "Avvia la creazione di una nuova note spesa.",
    tour_nuova_nota_spese: "Nuova note spesa",
    multi_monitor: "Multi monitor",
    descrizione_multi_monitor: "Apri la visualizzazione multi monitor per vedere i dettagli di più note spesa contemporaneamente.",
    ricalcolo_completato: "Ricalcolo completato con successo!",
    configurazione_orari: "Configurazione orari",
    funzionalita_abilitate: "Funzionalità abilitate",
    notifiche_email: "Notifiche email",
    integrazioni: "Integrazioni",
    tabella: "Tabella",
    descrizione_tabella:
      "Questa è la tabella principale dove sono elencate tutte le note spesa.Sono suddivise inizialmente per utenti, puoi raggrupparle per gruppo ma è anche possibile visualizzare le note spesa per altri criteri utilizzando i filtri disponibili.",
    tour_filtri: "Usa i filtri per visualizzare le note spesa in base a criteri specifici.",
    note_spese_approvate: "Il totale delle note spesa approvate.",
    totale_note_spese: "Totale note spesa",
    abilita_ricalcolo_mese: "Abilita ricalcolo mese",
    abilita_date_future: "Abilita modifica date future",
    visualizza_ferie_permessi_gruppo: "Visualizzazione ferie/permessi del gruppo",
    visualizza_ferie_aziendali: "Visualizza ferie aziendali",
    conferma_ricalcolo_mese_per: "Sei sicuro di voler ricalcolare il mese per",
    ricalcola_mese_per_utente: "Ricalcola mese per utente",
    conferma_ricalcolo_mese_generico: "Sei sicuro di voler ricalcolare il mese selezionato?",
    conferma_ricalcolo_mese: "Sei sicuro di voler ricalcolare il mese selezionato?",
    ricalcola_mese: "Ricalcola mese",
    senza_gruppo: "Nessun gruppo associato",
    sezione_disponibile_solo_in_modifica: "Questa sezione è disponibile solo in modalità modifica",
    legenda_mese_non_validato: "Il mese non è stato ancora validato, è possibile modificare lo stato delle note spese.",
    legenda_mese_validato: "Il mese è stato validato, non è più possibile modificare lo stato delle note spese.",
    legenda_menu_riga: "Apre il menu di azione per esportare in Excel o PDF",
    legenda_rifiuta_rimborso: "Non approva la nota spesa",
    legenda_conferma_rimborso: "Conferma approvazione nota spesa",
    legenda_visualizza_dettagli: "Visualizza i dettagli della nota spesa",
    nota_spesa_approvato: "Nota spesa approvata",
    nota_spesa_in_attesa: "Nota spesa in attesa di approvazione",
    nota_spesa_rifiutato: "Nota spesa rifiutata",
    legenda: "Legenda",
    dettagli_rapidi: "Dettagli rapidi",
    esporta_excel_mini: "Excel",
    esporta_pdf_mini: "PDF",
    blocca_sblocco_mese_tooltip: "Per validare/invalidare il mese, è necessario che tutte le note spese del mese siano approvate e/o rifiutate.",
    esporta_excel_tooltip: "Per esportare in Excel, è necessario che il mese sia validato.",
    esporta_pdf_tooltip_rimborsi: "Per esportare in PDF, è necessario che il mese sia validato.",
    conferma_sblocca_mese_header: "Conferma invalidazione mese",
    conferma_blocco_mese_header: "Conferma validazione mese",
    configurazione_ereditata_titolo: "Configurazione ereditata dal gruppo",
    configurazione_ereditata_descrizione:
      "L'utente sta ereditando la configurazione del gruppo. Ciò significa che le impostazioni di orario, pause e altre configurazioni specifiche del gruppo vengono applicate a questo utente. Se desideri modificare queste impostazioni, dovrai farlo a livello di gruppo, e tutti gli utenti associati a quel gruppo erediteranno automaticamente le modifiche.",
    filtra_gruppo: "Filtra per gruppo",
    filtra_tipo_spesa: "Filtra per tipo di spesa",
    filtra_stato: "Filtra per stato",
    filtra_mese_anno: "Filtra per mese e anno",
    filtra_numero_risorse: "Filtra per numero di risorse",
    filtra_risorsa: "Filtra per risorsa",
    filtra_risorsa_amministratore: "Filtra per risorsa/amministratore",
    note_spese: "Note spese",
    visualizza_limite_risorse: "Visualizza numero di risorse",
    orari_flessibili: "Utilizza orari flessibili",
    orari_liberi: "Utilizza orari liberi",
    orari_ordinari: "Utilizza orari ordinari",
    orari_turni: "Utilizza orari a turni",
    conferma_blocco_mese: "Sei sicuro di voler validare il mese di {mese}/{anno}? Validando il mese non sarà più possibile cambiarne lo stato.",
    conferma_sblocca_mese: "Sei sicuro di voler invalidare il mese di {mese}/{anno}? In questo modo sarà nuovamente possibile modificarne lo stato.",
    nessun_orario_impostato: "Nessun orario impostato",
    sola_lettura: "Solo lettura",
    validato: "Validato",
    nuovo: "Nuovo",
    resoconto_totale: "Resoconto totale",
    presenze_rilevate: "Presenze rilevate",
    presenze_calcolate: "Presenze calcolate",
    nessuna_timbratura_rilevata: "Nessuna timbratura rilevata",
    nessuna_pausa: "Nessuna pausa",
    modalita: "Modalita'",
    associazione_eseguita: "Associazione eseguita con successo!",
    conto_corrente: "Conto corrente",
    dettagli_banca: "Dettagli banca",
    nessun_dato_disponibile_per_blocco_mese: "Nessun dato disponibile per il blocco mese",
    tipo_file_non_supportato: "Tipo di file non supportato.",
    file: "File",
    tipologia: "Tipologia",
    creato_il: "Creato il",
    motivo: "Motivo",
    visualizza_dettagli: "Visualizza dettagli",
    info_codice_fiscale: "Informazioni sul codice fiscale",
    data: "Data",
    visualizza_allegato: "Visualizza allegato",
    scarica_allegato: "Scarica allegato",
    applica: "Applica",
    azioni_massive: "Azioni massive",
    rimuovi_raggruppamento: "Rimuovi raggruppamento",
    totale_generale: "Totale generale",
    periodicita_versamento: "Periodicità versamento",
    aggiungi_documenti: "Aggiungi documento/i",
    salva_documenti: "Salva documento/i",
    richieste_note_spese: "Numero di richieste : ",
    invia_per_approvazione: "Invia per approvazione",
    info_gruppo: "Informazioni sul gruppo",
    saldo_ore_attuale: "Saldo ore attuale",
    incremento_periodico: "Incremento periodico",
    gestione_saldo_ore_ferie: "Gestione saldo ore ferie",
    gestione_saldo_ore_permesso: "Gestione saldo ore permessi",
    fonte_scarico_default: "Default fonte di scarico",
    straordinari: "Straordinari",
    permessi: "Permessi",
    presenze: "Presenze",
    duplica_gruppo: "Duplica gruppo",
    duplica: "Duplica",
    visualizza_transazioni_ore_ferie: "Visualizza transazioni ore ferie",
    visualizza_transazioni_ore_permesso: "Visualizza transazioni ore permesso",
    saldo_ore_ferie_attuale: "Saldo ore ferie attuale",
    incremento_periodico_ore_ferie: "Incremento periodo ore di ferie",
    saldo_ore_permesso_attuale: "Saldo ore permesso attuale",
    incremento_periodico_ore_permesso: "Incremento periodo ore di permesso",
    tipo_spesa: "Tipo di spesa",
    nessun_gruppo_associato: "Nessun gruppo associato",
    raggruppa_per_gruppo: "Raggruppa per gruppo",
    informazioni: "Informazioni",
    impostazioni_notifiche: "Impostazioni notifiche",
    bollatura_non_attiva_titolo: "Timbratura non attiva",
    bollatura_non_attiva_descrizione: "La timbratura non è attiva per l'anagrafica attuale.",
    info_orari_1: "Informazioni sugli orari 1",
    info_orari_2: "Informazioni sugli orari 2",
    nessun_documento_associato: "Nessun documento associato",
    inserimento_spese: "Inserimento Spese",
    richiedi_note_spesa: "Nuova nota spesa",
    procedi: "Procedi",
    torna_indietro: "Torna indietro",
    info: "Info",
    info_gruppo_1:
      "I gruppi permettono di applicare rapidamente le stesse impostazioni a più risorse. Puoi creare un gruppo con orari, pause e altre configurazioni specifiche, e poi applicare queste impostazioni a tutte le risorse che appartengono a quel gruppo. In questo modo, se devi modificare un'impostazione, puoi farlo una sola volta nel gruppo e tutte le risorse associate erediteranno automaticamente la modifica.",
    info_gruppo_2:
      "Ad esempio, se hai un gruppo chiamato 'Team Vendite' con orari di lavoro specifici, puoi assegnare tutte le risorse del team a quel gruppo. Se poi decidi di modificare gli orari di lavoro per il 'Team Vendite', tutte le risorse associate a quel gruppo avranno automaticamente i nuovi orari senza doverli modificare singolarmente.",
    tfr: "TFR",
    info_codice_fiscale_1: "Il codice fiscale deve essere composto da 16 caratteri alfanumerici. Assicurati di inserire un codice fiscale valido.",
    info_codice_fiscale_2:
      "La compilazione del dato permette l'autocompletamento di data di nascita, comune di nascita e provincia di nascita, ma è comunque possibile modificare manualmente questi campi dopo l'inserimento del codice fiscale.",
    associa_azienda: "Associa azienda",
    utente_gia_associato_azienda: "L'utente esiste già nel sistema.",
    vuoi_associare_utente_azienda:
      "Vuoi associare questo utente all'azienda? I dati anagrafici e di accesso rimarranno invariati, ma l'utente potrà accedere anche a questa azienda.",
    nessun_elemento_archiviato: "Nessun elemento archiviato",
    non_ci_sono_elementi_archiviati_per_questa_pagina: "Non ci sono elementi archiviati per questa pagina",
    destinazione_tfr: "Destinazione TFR",
    in_azienda: "In azienda",
    fondo_esterno: "Fondo pensione esterno",
    nome_fondo: "Nome fondo",
    data_adesione: "Data adesione",
    quando_versare: "Quando versare",
    codice_fondo_adesione: "Codice fondo adesione",
    iban_fondo: "IBAN fondo",
    intestatario_conto: "Intestatario conto",
    matricola: "Matricola",
    salva_configurazione: "Salva configurazione delle colonne",
    seleziona_colonne: "Seleziona colonne",
    colonne_selezionate: "colonne selezionate",
    titolo_auguri_compleanno: "AUGURI DI BUON COMPLEANNO!",
    sottotitolo_auguri_compleanno: "In occasione di questa giornata speciale, M2SISTEMI S.R.L. desidera porgerle i suoi più sentiti auguri di compleanno.",
    nessuna_risorsa_trovata: "Nessuna risorsa trovata",
    inserisci_ore: "Inserisci ore",
    totali_retribuzione_speciale: "Totali ore di retribuzione speciale",
    ore_lavorate_retribuzione_speciale_effettive: "Ore di retribuzione speciale effettive",
    ore_lavorate_retribuzione_speciale_approssimate: "Ore di retribuzione speciale lavorate",
    me_stesso: "Me stesso",
    rimborso_per_altri: "Nota spesa per altri",
    esportazione_rispetto_a_mese_e_anno:
      "L'esportazione avverrà rispetto al mese e all'anno selezionati. Se è presente una risorsa selezionata, le esportazioni porteranno le informazioni riferite a quella risorsa, altrimenti saranno riferite a tutte le risorse.",
    not_authorized: "Non autorizzato",
    nessuno: "Nessuno",
    tipo_impatto: "Tipo di impatto",
    seleziona_risorsa_per_visualizzare_resoconto: "Seleziona una risorsa per visualizzare il resoconto",
    nessuna_risorsa_trovata: "Nessun risorsa/amministratore trovato",
    risorsa_amministratori: "Risorse/Amministratori",
    caricamento: "Caricamento",
    disabilita_modifica: "Disabilita modifica",
    abilita_modifica: "Abilita modifica",
    prefisso_chiave_obbligatorio: "(deve iniziare con 'KioskKey' per essere riconosciuta come chiave kiosk)",
    dati_obbligatori_mancanti: "Dati obbligatori mancanti",
    salva_settimana: "Salva settimana",
    pause: "Pause",
    bollatura_effettiva: "Bollatura effettiva",
    seleziona_riga: "Seleziona una riga tramite la casella sulla sinistra",
    nessun_dato_bollatura: "Nessuna presenza rilevata per la data selezionata.",
    comprimi_riepiloghi: "Comprimi i riepiloghi",
    espandi_riepiloghi: "Espandi i riepiloghi",
    controlli: "Controlli",
    pause_interne_orario: "Le pause devono essere all'interno dell'orario del turno",
    password_aggiornata_con_successo: "Password aggiornata con successo!",
    versione: "Versione",
    pianifica_turni_temporanei: "Pianifica Turni Temporanei",
    seleziona_prima_risorsa: "Seleziona una risorsa",
    seleziona_prima_azienda: "Seleziona un'azienda",
    clicca_per_ingrandire: "Clicca per ingrandire",
    presenze_non_trovate: "Non sono state trovate presenze per questo giorno",
    panoramica_rapida_medie_totali: "Panoramica rapida ore medie",
    generazione_excel_in_corso: "Generazione Excel in corso...",
    excel_generato_con_successo: "Excel generato con successo!",
    valore_ereditato: "Valore ereditato",
    nome_gruppo_padre: "Gruppo padre",
    totale_gruppi: "Totale gruppi",
    seleziona_risorse_amministratori: "Seleziona risorse/amministratori",
    durata_massima_straordinario_obbligatorio: "Durata straordinario obbligatorio (minimo 00:01)",
    selezionare_almeno_un_tipo_straordinario: "Selezionare almeno un tipo di straordinario",
    orari_turni_obbligatori: "Inserire gli orari per tutti i turni obbligatori",
    orario_fine_obbligatorio: "Orario di inizio impostato, è necessario impostare anche l'<strong>orario di fine</strong>",
    ultimo_aggiornamento: "Ultimo aggiornamento: ",
    nessun_ritardo: "Nessun ritardo",
    seleziona_immagine_valida: "Seleziona un'immagine valida",
    immagine_inferiore_5mb: "Seleziona un'immagine valida (inferiore a 5MB)",
    dispositivo_rimosso: "Dispositivo rimosso con successo",
    sei_offline: "Sei offline: le modifiche non vengono salvate",
    sei_stato_disconnesso_dispositivo: "Sei stato disconnesso da questo dispositivo",
    sei_stato_disconnesso_dispositivo_messaggio: "Per motivi di sicurezza, se non sei stato tu, ti consigliamo di cambiare la password.",
    ora_speciale_non_trovata_o_non_autorizzato: "Ora speciale non trovata o non autorizzato",
    inizio_ora: "Inizio ora",
    fine_ora: "Fine ora",
    accesso_non_autorizzato: "Accesso non autorizzato",
    non_hai_permessi: "Non hai i permessi necessari per accedere a questa pagina",
    escludi_utenti: "Escludi amministratori/risorse dalle ore di retribuzione speciale",
    nega_visualizzazione_riepilogo_mese_senza_validazione: "Nega la visualizzazione del mese prima della validazione",
    straordinari_abilitati_anticipati: "Abilita straordinari anticipati",
    straordinari_abilitati_posticipati: "Abilita straordinari posticipati",
    inizio_retribuzione_speciale: "Inizio retribuzione speciale",
    fine_retribuzione_speciale: "Fine retribuzione speciale",
    sigla: "Sigla",
    ore_di_retribuzione: "Ore di retribuzione speciale",
    ore_retribuzione_speciale_intestazione: "Ore retribuzione speciale",
    gruppo_ereditato_con_successo: "Dati applicati con successo dal gruppo",
    eredita_da_gruppo: "Applica configurazione del gruppo",
    spiegazione_eredita_da_gruppo_gruppo: "Se attivo, l'utente eredita dal gruppo le impostazioni di bollatura.",
    ereditato_da_gruppo: "Dati applicati dal gruppo",
    dashboard: "Dashboard",
    dati_crea_mancanti_annuncio: "Dati mancanti per creare l'annuncio",
    dati_modifica_mancanti_annuncio: "Dati mancanti per modificare l'annuncio",
    visualizza_dashboard: "Visualizza sulla dashboard",
    bacheca: "Bacheca",
    posizioni: "Posizioni",
    mappa_schermo_intero: "Mappa a schermo intero",
    nessuna_posizione_remota: "Nessuna timbratura da remoto nel mese",
    ore: "Ore",
    lavorate: "Lavorate",
    straordinario: "Straordinario",
    ritardo: "Ritardo",
    ferie: "Ferie",
    malattia: "Malattia",
    permesso: "Permesso",
    originale: "Originale",
    copia: "Copia",
    mappa: "Mappa",
    presenza: "Presenza",
    impostazioni_globali: "Impostazioni globali",
    note_mese: "Note del mese",
    blocca_sblocco_mese: "Valida/Rimuovi validazione mese",
    rimuovi_validazione_mese: "Rimuovi validazione mese",
    valida_mese: "Valida mese",
    esporta_phf_ascom: "Esporta cedolino PHF",
    esporta_txt_ascom: "Esporta presenze CSV LUL",
    dati_esportazione_ascom: "Dati esportazione ASCOM",
    matricola_ascom: "Matricola",
    azienda_ascom: "Azienda ASCOM",
    tipo_contratto_ascom: "Tipo contratto",
    paga_oraria: "Paga oraria",
    ore_settimanali_pt: "Ore settimanali part-time",
    data_inizio_contratto: "Data inizio contratto",
    data_fine_contratto: "Data fine contratto",
    full_time: "Full time",
    part_time_p: "Part time",
    part_time_m: "Part time misto",
    file_esportati_per: "File esportati per",
    righe: "Righe",
    generazione_ascom_in_corso: "Generazione file ASCOM in corso...",
    esportazione_completata: "Esportazione completata",
    ore_totali: "Ore totali",
    dettagli_giornata: "Dettagli giornata",
    inizio_effettivo: "Inizio effettivo",
    fine_effettivo: "Fine effettivo",
    inizio_approssimato: "Inizio approssimato",
    fine_approssimato: "Fine approssimato",
    orario_effettivo: "Orario effettivo",
    orario_approssimato: "Orario approssimato",
    remoto: "Remoto",
    in_sede: "In sede",
    rilevazione_presenze: "Rilevazione presenze",
    menu_annunci: "Bacheca",
    menu_dimenticanze: "Segnalazioni",
    inserisci_note: "Inserisci note",
    messaggio: "Messaggio",
    google: "Google Api",
    ore_straordinario: "Ore straordinario",
    seleziona_tutto: "Seleziona tutto",
    data_scadenza_licenza: "Data di scadenza della licenza",
    approssimazione_orario: "Arrotondamento orario bollatrice",
    intervallo_validita_turno: "Intervallo di validità del turno",
    minuti_ritardo_accettabile: "Minuti di tolleranza prima di considerare un ingresso come ritardo",
    minuti_minimi_straordinario: "Minuti minimi per considerare un'attività come straordinario",
    notifiche_permessi: "Destinatari notifiche permessi e ferie",
    notifiche_ingressi_in_ritardo: "Destinatari notifiche ritardo",
    dopo_quante_ore_inviare_email_ritardo_ingresso: "Invia l'email di ritardo solo dopo",
    ore_retribuzione_speciale: "Abilita ore di retribuzione speciale",
    invia_email_ritardo_ingresso: "Invia email in caso di ritardo all'ingresso",
    generazione_file_ascom: "Abilita generazione file aggiuntivi per l'integrazione con sistemi esterni",
    copia_url: "Copia URL",
    url_copiato: "URL copiato negli appunti",
    file_presenti: "File presenti",
    gruppo_creato: "Gruppo creato con successo!",
    mostra_bottoni_pausa: "Mostra bottoni pausa",
    // Help texts per campi orari
    intervallo_validita_turno_help: "Quanto tempo prima e dopo l'orario previsto del turno viene accettata una timbratura",
    approssimazione_orario_help: "Intervallo a cui arrotondare l'orario registrato dalla bollatrice",
    minuti_ritardo_accettabile_help: "Soglia di tolleranza prima che un ingresso venga segnalato come ritardo",
    minuti_minimi_straordinario_help: "Tempo minimo oltre l'orario previsto per conteggiare lo straordinario",
    dopo_quante_ore_inviare_email_ritardo_ingresso_help: "Invia la notifica email solo quando il ritardo residuo supera la soglia selezionata",
    // Gruppi toggle
    gruppo_tipologie_orario: "Tipologie di orario",
    gruppo_tipologie_orario_help:
      "Seleziona quali modalit\u00e0 di gestione orario abilitare per l'azienda. Puoi attivarne pi\u00f9 di una contemporaneamente.",
    gruppo_funzionalita_generali: "Funzionalit\u00e0 generali",
    gruppo_export_integrazioni: "Export e integrazioni dati",
    // --- Refactor gruppi impostazioni ---
    gruppo_banca_ore: "Banca ore",
    gruppo_banca_ore_help: "Gestione dell'accumulo e visualizzazione della banca ore.",
    gruppo_straordinari: "Straordinari",
    gruppo_straordinari_help: "Regole di calcolo e arrotondamento degli straordinari.",
    gruppo_ferie_permessi: "Ferie e permessi",
    gruppo_ferie_permessi_help: "Regole per la richiesta e la visualizzazione di ferie e permessi.",
    gruppo_timbrature: "Timbrature",
    gruppo_timbrature_help: "Opzioni relative alle bollature e alle pause.",
    gruppo_riepilogo_ricalcolo: "Riepilogo e ricalcolo",
    gruppo_riepilogo_ricalcolo_help: "Regole di visualizzazione del riepilogo e ricalcolo mensile.",
    gruppo_retribuzione_speciale: "Retribuzione speciale",
    gruppo_retribuzione_speciale_help: "Gestione delle fasce di retribuzione speciale.",
    gruppo_guide_in_app: "Guide in app",
    gruppo_guide_in_app_help: "Le guide che spiegano le pagine agli amministratori dell'azienda.",
    // Nuovi campi azienda
    vieta_richiesta_ferie_vigilia: "Vieta richiesta ferie in vigilia",
    vieta_richiesta_ferie_vigilia_help: "Se attivo, vieta la richiesta di ferie per il giorno precedente (vigilia) e quello successivo al range richiesto.",
    abilita_tolleranza_bollatura_fine_pausa: "Tolleranza bollatura fine pausa",
    abilita_tolleranza_bollatura_fine_pausa_help:
      "Se attivo, applica la tolleranza di bollatura anche in fase di 'FINE PAUSA', come gi\u00e0 avviene in 'INIZIO TURNO'.",
    arrotondamento_straordinari: "Arrotonda straordinari",
    arrotondamento_straordinari_help: "Se attivo, arrotonda gli straordinari in base all'approssimazione oraria impostata.",
    ignora_straordinari_attivi_per_giorni_facolativi: "Ignora straordinari attivi nei giorni facoltativi",
    ignora_straordinari_attivi_per_giorni_facolativi_help:
      "Se attivo, in presenza di bollature nei giorni facoltativi ignora l'impostazione degli straordinari attivi e conteggia comunque le ore straordinarie.",
    valore_arrotondamento_straordinari: "Valore di arrotondamento",
    opzione_arrotondamento_straordinari: "Modalit\u00e0 di arrotondamento",
    arrotonda_per_eccedenza: "Per eccedenza",
    arrotonda_per_difetto: "Per difetto",
    abilita_disabilita_ferie: "Periodi bloccati per ferie e permessi",
    abilita_disabilita_ferie_help:
      "Se attivo, puoi definire periodi in cui le richieste di ferie e permessi sono bloccate o segnalate, per alcune tipologie e alcune persone.",
    abilita_richiesta_ferie_permessi_per_passato: "Abilita richieste ferie e permessi per giorni passati",
    abilita_richiesta_ferie_permessi_per_passato_help: "Se attivo, consente di inserire richieste di ferie e permessi anche per date gi\u00e0 trascorse.",
    slot_permessi_ore: "Slot permessi a ore",
    slot_permessi_ore_help: "Intervallo di minuti selezionabile negli orari di inizio e fine dei permessi a ore.",
    // DataTable date ferie disabilitate
    date_ferie_disabilitate: "Periodi bloccati",
    date_ferie_disabilitate_help: "Intervalli di date in cui le richieste di ferie e permessi sono bloccate o segnalate.",
    creato_da: "Creato da",
    aggiungi_periodo: "Aggiungi periodo",
    modifica_periodo: "Modifica periodo",
    valore_arrotondamento_obbligatorio: "Seleziona un valore di arrotondamento.",
    nessun_periodo: "Nessun periodo definito",
    conferma_elimina_periodo: "Eliminare questo periodo?",
    periodo_creato: "Periodo creato",
    periodo_aggiornato: "Periodo aggiornato",
    periodo_eliminato: "Periodo eliminato",
    date_periodo_non_valide: "La data di fine non pu\u00f2 precedere la data di inizio.",
    // Finestra del periodo bloccato (spec 2026-10-09 periodi-bloccati \u00a73, \u00a78, \u00a710)
    periodo_motivo: "Motivo",
    periodo_motivo_help: "Lo leggono i dipendenti quando scelgono le date.",
    periodo_effetto: "Effetto",
    periodo_effetto_blocco: "Blocca le richieste",
    periodo_effetto_blocco_help: "I giorni non si scelgono e la richiesta non parte.",
    periodo_effetto_avviso: "Solo avviso",
    periodo_effetto_avviso_help:
      "I giorni si scelgono; chi chiede conferma un avviso e chi approva vede la richiesta segnata \u00abPeriodo critico\u00bb.",
    periodo_effetto_blocco_breve: "Blocca",
    periodo_effetto_avviso_breve: "Avviso",
    periodo_tipologie: "Tipologie",
    periodo_tipologie_tutte: "Tutte",
    periodo_tipologie_solo: "Solo queste",
    periodo_tipologie_escluse: "Tutte tranne queste",
    periodo_scelta_solo_ferie: "Solo ferie",
    periodo_scelta_solo_giornata: "Solo a giornata intera",
    periodo_nessuna_ferie: "Nessuna tipologia di ferie fra quelle abilitate",
    periodo_chi: "Chi",
    periodo_chi_tutti: "Tutti",
    periodo_chi_scelti: "Solo gruppi e persone scelti",
    periodo_gruppi: "Gruppi",
    periodo_persone: "Persone",
    periodo_esenti_amministratori: "Gli amministratori possono inserire comunque",
    periodo_esenti_amministratori_help:
      "Vale per chi inserisce la richiesta: amministratori e super amministratori, per s\u00e9 o per altri.",
    periodo_attivo: "Attivo",
    // Finestra del periodo: gruppi, segnaposto, riepilogo
    periodo_sezione_quando: "Motivo e date",
    periodo_sezione_chi: "A chi vale",
    periodo_scelta_rapida: "Scelta rapida:",
    periodo_scelta_solo_ferie_help: "Sceglie \u00abSolo queste\u00bb con le tipologie di ferie abilitate.",
    periodo_scelta_solo_giornata_help: "Sceglie \u00abSolo queste\u00bb con le tipologie abilitate a giornata intera.",
    periodo_tipologia_disattivata: "(disattivata)",
    periodo_tipologie_scegli: "Scegli le tipologie",
    periodo_tipologie_da_escludere: "Scegli le tipologie da escludere",
    periodo_nessun_gruppo: "Nessun gruppo",
    periodo_nessuna_persona: "Nessuna persona",
    periodo_riepilogo: "Riepilogo",
    periodo_sospeso: "Sospeso: finch\u00e9 \u00abAttivo\u00bb \u00e8 spento, il periodo non conta.",
    periodo_motivo_mancante: "Scrivi il motivo del periodo.",
    periodo_categorie_mancanti: "Scegli almeno una tipologia.",
    periodo_persone_mancanti: "Scegli almeno un gruppo o una persona.",
    richieste_esistenti_titolo: "Richieste gi\u00e0 presenti nel periodo",
    richieste_esistenti_testo:
      "In questo periodo ci sono gi\u00e0 {totale} richieste che rientrano nel blocco: {in_attesa} in attesa e {approvate} approvate. Non vengono annullate n\u00e9 modificate: valutale dal \u00abResoconto\u00bb dei permessi.",
    ho_capito: "Ho capito",
    // Help texts per toggle orari
    orari_ordinari_help: "Orario fisso giornaliero",
    orari_flessibili_help: "Orario con fascia di ingresso/uscita variabile entro un intervallo",
    orari_liberi_help: "Nessun vincolo di orario, conta solo il totale ore giornaliere",
    orari_turni_help: "Turni predefiniti assegnabili ai dipendenti su base settimanale",
    // Help texts per toggle generali
    ore_retribuzione_speciale_help: "Permette di configurare categorie di ore con retribuzione maggiorata",
    banca_ore_help: "Accumula le ore di straordinario in un saldo utilizzabile come permessi futuri",
    mostra_bottoni_pausa_help: "Mostra i pulsanti di inizio/fine pausa nella schermata di timbratura",
    abilita_ricalcolo_mese_help: "Consente di ricalcolare le ore del mese dalla pagina resoconto",
    abilita_date_future_help:
      "Se attiva, nella pagina di rilevazione presenze sarà possibile modificare anche le date future, ad esempio per inserire mutua o eventi analoghi.",
    visualizza_ferie_permessi_gruppo_help:
      "Se attiva, ogni utente dell'azienda vede nei calendari le ferie e i permessi confermati dei colleghi appartenenti al proprio gruppo di lavoro.",
    visualizza_ferie_aziendali_help: "Se attivo, l'utente vede nei calendari tutte le ferie e i permessi confermati dell'azienda.",
    nega_visualizzazione_riepilogo_mese_senza_validazione_help:
      "I dipendenti non potranno vedere il riepilogo mensile finch\u00e9 non viene validato dall'amministratore",
    abilita_guide: "Abilita guide in app",
    abilita_guide_help:
      "Se attivo, super amministratori e amministratori dell'azienda vedono la sezione «Guide» del menu e il pulsante «Guida» nelle pagine. Il cambio si vede al loro prossimo accesso o cambio azienda.",
    // Help texts per toggle export
    generazione_file_ascom_help: "Genera automaticamente file aggiuntivi per l'integrazione con sistemi esterni",
    // Help texts per notifiche email
    notifiche_permessi_help: "Questi indirizzi riceveranno una notifica ogni volta che un dipendente invia una richiesta di permesso o ferie",
    invia_email_permessi: "Invia email per permessi e ferie",
    invia_email_permessi_help: "Se attivo, invia automaticamente un'email quando un dipendente invia una richiesta di permesso o ferie",
    invia_email_ritardo_ingresso_help: "Se attivo, invia automaticamente un'email quando un dipendente entra in ritardo rispetto all'orario previsto",
    invia_email_rimborso: "Invia email per rimborsi spese",
    invia_email_rimborso_help: "Se attivo, invia automaticamente un'email quando un dipendente invia una richiesta di rimborso spese",
    notifiche_rimborso_spese: "Destinatari notifiche rimborso spese",
    chips_email_placeholder: "Digita un'e-mail e premi Invio",
    email_destinatari_obbligatoria: "Inserisci almeno un indirizzo email valido",
    mostra_meteo: "Mostra meteo",
    seleziona_anno: "Seleziona anno",
    seleziona_mese: "Seleziona mese",
    nessun_mese_validato_disponibile: "Nessun mese validato disponibile per l'anno selezionato",
    seleziona_risorsa: "Seleziona risorsa",
    menu: "Menu",
    password_aggiornata_con_successo: "Password aggiornata con successo!",
    email_inviata_password_aggiornata: "Email inviata e password aggiornata con successo!",
    errore_invio_email_password_aggiornata: "Errore nell'invio dell'email ma password aggiornata",
    esporta_pdf_tooltip: "Esporta in PDF",
    google_api_vision_descrizione:
      "Abilita l'integrazione con Google API Vision per l'estrazione automatica dei dati dai documenti caricati. Se abilitato, i documenti caricati verranno analizzati utilizzando i servizi di Google per estrarre informazioni chiave come nome, cognome, codice fiscale e data di nascita. Per utilizzare questa funzionalità, è necessario fornire le credenziali JSON di Google API Vision nelle impostazioni dell'azienda.",
    azienda_aggiornata_successo: "Azienda aggiornata con successo",
    errore_salvataggio: "Errore durante il salvataggio",
    mese_validato: "Il mese è validato: per modificare le note serve togliere la validazione",
    banca_ore_al_tetto: "La banca ore ha già raggiunto il massimo: non si può convertire altro",
    banca_ore_oltre_tetto_rimuovi: "Lo straordinario supera il massimo della banca ore: converti mantenendo gli straordinari",
    banca_ore_massimo_convertibile: "Entra in banca ore solo {ore} (massimo {massimo}): il resto resta straordinario del mese",
    impostazione_non_valida: "Un'impostazione ha un valore non valido",
    campo_riservato_m2: "Questa impostazione la può cambiare solo l'assistenza M2",
    credenziali_vision_configurate: "Credenziali configurate: incolla il nuovo file per sostituirle",
    credenziali_vision_non_valide: "Le credenziali Google Vision non sono valide (serve il file JSON del service account)",
    google_api_vision_credenziali: "Copia e incolla qui le credenziali JSON per Google API Vision",
    errore_upload_logo: "Errore durante l'upload del logo",
    errore_caricamento: "Errore durante il caricamento dei dati",
    dati_aggiornati_successo: "Dati aggiornati con successo!",
    google_api_vision: "Google API Vision",
    impostazioni: "Impostazioni",
    elaborazione: "Elaborazione in corso...",
    affidabilita_risultati: "Affidabilità risultati",
    verifica_dati_inseriti: "Verifica i dati inseriti",
    estrai_dati: "Estrai dati",
    o_clicca_per_sfogliare: "o clicca per sfogliare",
    trascina_il_documento: "Trascina il documento qui",
    rilascia_qui: "Rilascia qui",
    documento_identita: "Documento di Identità",
    menu_cestino: "Cestino",
    retribuita: "Retribuita",
    visualizza_transazioni_banca_ore: "Visualizza transazioni banca ore",
    documenti_titolo: "Documenti",
    identita: "Identità",
    nessun_documento_caricato: "Nessun documento caricato",
    file_sconosciuto: "File sconosciuto",
    conferma_rimborso: "Approva",
    rifiuta_rimborso: "Rifiuta",
    rimborsi: "Note spese",
    nota_spesa: "Nota spesa",
    mostra_kpi: "Mostra statistiche",
    nascondi_kpi: "Nascondi statistiche",
    motivazione: "Motivazione",
    data_acquisto: "Data acquisto",
    dati: "Dati",
    documenti_totali: "Documenti totali",
    nessun_file_allegato: "Nessun file allegato",
    messaggio_conferma_archivi_selezionati: "Gli elementi selezionati sono stati archiviati con successo!",
    documento_aggiornato_con_successo: "Documento aggiornato con successo!",
    creato_il: "Creato il ",
    inserito_il: "Inserito il ",
    eliminazione_file: "Eliminazione file",
    file_allegati: "File allegati",
    conferma_eliminazione_file: "Sei sicuro di voler eliminare questo file?",
    elimina: "Elimina",
    documenti_caricati: "Documenti caricati con successo!",
    passaporto: "Passaporto",
    busta_paga: "Busta paga",
    tipologia_documento: "Tipo di documento",
    file_obbligatorio: "È necessario selezionare un file",
    almeno_un_file_obbligatorio: "È necessario selezionare almeno un file",
    seleziona_tipologia: "Seleziona tipo di documento",
    seleziona_tipologia_per_tutti_i_file: "Seleziona il tipo di documento per tutti i file prima di procedere",
    contratto: "Contratto",
    curriculum: "Curriculum",
    patente: "Patente",
    certificato: "Certificato",
    altro: "Altro",
    analisi_documento: "Analisi documento",
    suggerito: "Suggerito",
    applica_suggerimento: "Applica",
    classificazione_completata: "Classificazione completata",
    classificazione_fallita: "Classificazione fallita",
    impossibile_classificare_documento: "Impossibile classificare il documento",
    errore_classificazione: "Errore classificazione",
    errore_generico_classificazione: "Errore durante l'analisi del documento",
    campi_estratti: "Informazioni estratte",
    nome: "Nome",
    cognome: "Cognome",
    codice_fiscale: "Codice Fiscale",
    trascina_file_qui: "Trascina il file qui o clicca per selezionarlo",
    documenti: "Documenti",
    carica_documento: "Carica documento",
    seleziona_utente: "Seleziona risorsa",
    seleziona_utente_prima_upload: "Seleziona una risorsa per poter caricare documenti",
    validita: "Validità",
    intervallo_foto_random: "Intervallo foto random",
    qr_code_non_corrispondente_azienda: "Il codice QR non corrisponde ad alcun utente valido per l'azienda attuale",
    path: "Percorso",
    logo_chiaro: "Logo tema chiaro",
    logo_scuro: "Logo tema scuro",
    sfondo_chiaro: "Sfondo tema chiaro",
    sfondo_scuro: "Sfondo tema scuro",
    nome_documento: "Nome",
    menu_archivio: "Archivio documenti",
    filtri_avanzati: "Filtri avanzati",
    tutte_le_aziende: "Tutte le aziende",
    tutti_i_dipendenti: "Tutti i dipendenti",
    tutte_le_tipologie: "Tutte le tipologie",
    pulisci_filtri: "Pulisci filtri",
    tipologie: "Tipologie",
    tipologia_documento: "Tipologia",
    menu_rimborsi: "Note spese",
    menu_documenti: "Documenti",
    menu_i_miei_documenti: "I miei documenti",
    menu_le_mie_richieste: "Le mie richieste",
    menu_develop: "Sviluppo",
    calcolo_giorni_rinnovo_in_corso: "Calcolo giorni al prossimo rinnovo in corso...",
    compilare_campi_obbligatori: "Compilare tutti i campi obbligatori evidenziati",
    rinnovo_ok: "Rinnovo in regola",
    rinnovo_in_scadenza: "Rinnovo in scadenza",
    rinnovo_urgente: "Rinnovo urgente",
    giorni_al_prossimo_rinnovo: "Giorni al prossimo rinnovo",
    rimuovi: "Rimuovi",
    azienda_selezionata: "Azienda selezionata",
    gruppo_aggiornato: "Il gruppo è stato aggiornato!",
    caricamento_in_corso: "Caricamento in corso...",
    capogruppo: "Capogruppo",
    solo_un_capogruppo_per_gruppo: "È possibile selezionare solamente un capogruppo per gruppo",
    dato_ricaricato: "Dato ricaricato con successo!",
    titolo: "Titolo",
    testo: "Testo",
    valido_dal: "Valido dal",
    valido_al: "Valido al",
    kiosks: "Kiosks",
    codice_anydesk: "Codice Anydesk",
    ricarica_pagina: "Ricarica pagina",
    mai: "Mai",
    ultima_presenza: "Ultima presenza",
    data_ultimo_ricaricamento: "Data ultimo ricaricamento",
    impostazioni_visualizzazione: "Impostazioni di visualizzazione",
    menu_kiosk: "Kiosk",
    chiave: "Chiave",
    valore_chiave: "Valore chiave",
    logo: "Logo",
    larghezza_logo: "Larghezza logo",
    altezza_logo: "Altezza logo",
    sfondo: "Sfondo",
    eliminazione_eseguita: "Eliminazione eseguita con successo!",
    successo: "Successo",
    aggiornamento_eseguito: "Aggiornamento eseguito con successo!",
    elimina_licenza: "Elimina licenza",
    impossibile_cancellare_licenza_collegata_aziende: "Impossibile cancellare la licenza perché collegata ad una o più aziende.",
    conferma_cancellazione_licenza: "Sei sicuro di voler eliminare la licenza selezionata?",
    file_selezionati: "File selezionati per il caricamento",
    prossimo_rinnovo_licenza: "Prossimo rinnovo licenza",
    nuova_licenza: "Nuova licenza",
    utenti_rimanenti: "Utenti rimanenti",
    utilizzo_licenza: "Utilizzo licenza",
    seleziona_elemento: "Seleziona elemento",
    modifica_licenza: "Modifica licenza",
    numero_utenti: "Numero utenti",
    numero_utenti_attivi: "Numero utenti attivi",
    numero_utenti_disponibili: "Numero utenti disponibili",
    licenza: "Licenza",
    licenze: "Licenze",
    dettagli_licenza: "Dettagli licenza",
    crea_licenza: "Crea licenza",
    creazione_licenza: "Creazione licenza",
    gestione_licenze: "Gestione licenze",
    licenza_attiva: "Licenza attiva",
    login_info_1: "Software di rilevazione presenze.",
    login_info_2: "Gestione ferie e permessi",
    login_info_3: "Caricamento cedolini paga",
    login_info_4: "Reportistica avanzata",
    effettua_accesso: "Effettua l'accesso",
    tema_dimensione_testo: "Tema e dimensione testo",
    sessione_protetta: "Sessione protetta",
    tipologia_permesso: "Tipologia Permesso",
    allegati_caricati: "Allegati caricati",
    dati_documento: "Dati documento",
    foto_profilo_aggiornata: "Foto profilo aggiornata",
    attendi_reindirizzamento: "Attendi il reindirizzamento...",
    benvenuto_in_todoe: "Benvenuto in Todo-E",
    benvenuto: "Benvenuto",
    inserisci_le_tue_credenziali: "Inserisci le tue credenziali per continuare",
    primo_login_potrebbe_impiegarci_un_po: "Primo login: potrebbe impiegarci un po' di tempo a configurare tutto per te...",
    login_controllo_sessione_fallito: "Controllo sessione fallito, effettua nuovamente il login",
    dispositivi_collegati_descrizione: "Numero di dispositivi attualmente collegati",
    dispositivi: "Dispositivi",
    nome_dispositivo: "Nome dispositivo",
    icona: "Icona",
    nessun_dispositivo_registrato: "Nessun dispositivo registrato",
    rimuovi_dispositivo_corrente_avviso:
      "Attenzione: stai per rimuovere il dispositivo corrente. Procedendo, effettuerai il logout dall'applicazione e dovrai nuovamente verificare il dispositivo.",
    dispositivo_corrente: "Dispositivo corrente",
    conferma_rimozione_dispositivo_nome: "Confermi la rimozione del dispositivo",
    login_controllo_sessione: "Controllo sessione in corso...",
    salvataggio_dispositivo_titolo: "Stiamo salvando il tuo dispositivo…",
    salvataggio_dispositivo_sottotitolo: "Così al prossimo accesso sarà più veloce e immediato",
    salvataggio_dispositivo_descrizione_1: "Stiamo registrando questo dispositivo per riconoscerlo automaticamente.",
    salvataggio_dispositivo_descrizione_2: "È un passaggio rapido: ti eviterà verifiche ripetute e renderà l’accesso più fluido.",
    login_scegli_autenticazione: "Scegli il metodo di autenticazione per continuare",
    codice_email: "Codice via email",
    salvataggio_dispositivo_hint: "Non chiudere la pagina: mancano solo pochi secondi.",
    codice_non_valido: "Codice non valido",
    prosegui: "Prosegui",
    verifica_metodi_dispositivo: "È richiesta la verifica del dispositivo per confermare l'accesso.",
    verifica_metodi_dispositivo_descrizione:
      "Per motivi di sicurezza, è necessario verificare il dispositivo da cui stai effettuando l'accesso. Scegli uno dei metodi di verifica disponibili per procedere con il login.",
    download_avvenuto_con_successo: "Download avvenuto con successo!",
    conferma_permesso: "Conferma permesso",
    rifiuta_permesso: "Rifiuta permesso",
    voce: "Voce",
    revoca_conferma_permesso: "Revoca conferma permesso",
    data_archiviazione: "Data archiviazione",
    archivio_elimina_selezionati: "Elimina selezionati",
    elementi_archiviati: "Elementi archiviati",
    menu_log: "Log",
    menu_feedback: "Feedback",
    // Feedback dei clienti a M2 (spec 2026-10-26-feedback-utenti)
    feedback_titolo_invito: "Ci dai un parere su ToDo-E?",
    feedback_sottotitolo_invito: "Bastano pochi secondi: un voto e, se vuoi, due righe. Leggiamo tutto.",
    feedback_titolo_menu: "Lascia un feedback",
    feedback_commento_placeholder: "Cosa ti piace, cosa miglioreresti? (facoltativo)",
    feedback_invia: "Invia",
    feedback_non_ora: "Non ora",
    feedback_grazie: "Grazie! Il tuo feedback è arrivato al team ToDo-E.",
    feedback_errore_invio: "Non siamo riusciti a inviare il feedback: riprova tra poco.",
    feedback_voto_non_valido: "Scegli un voto da 1 a 5 stelle.",
    feedback_commento_troppo_lungo: "Il commento supera i 2000 caratteri.",
    feedback_troppo_ravvicinato: "Hai appena inviato un feedback: riprova tra un minuto.",
    feedback_errore_caricamento: "Non siamo riusciti a caricare i feedback.",
    feedback_media: "Voto medio",
    feedback_totale: "Feedback ricevuti",
    feedback_da_leggere: "Da leggere",
    feedback_solo_da_leggere: "Solo da leggere",
    feedback_segna_da_leggere: "Segna da leggere",
    feedback_dettaglio: "Dettaglio feedback",
    feedback_utente: "Utente",
    feedback_voto: "Voto",
    feedback_commento: "Commento",
    feedback_origine: "Provenienza",
    feedback_origine_invito: "Popup",
    feedback_origine_menu: "Pulsante",
    feedback_piattaforma: "Piattaforma",
    feedback_dal: "Dal",
    feedback_al: "Al",
    menu_super_amministratori: "Super Amministratori",
    menu_archiviazione_dati: "Archivio",
    minimo_16_caratteri: "Il codice fiscale deve contenere 16 caratteri",
    archiviazione_eseguita: "Archiviazione eseguita con successo!",
    statistiche: "Statistiche",
    aziende: "Aziende",
    azienda: "Azienda",
    dalla_cache: "Cache",
    gruppi: "Gruppi",
    amministratori: "Amministratori",
    "super-amministratore": "Super Amministratore",
    risorse: "Risorse",
    ore_pausa: "Ore pausa",
    scarica: "Scarica",
    visualizza: "Visualizza",
    allegati_gia_presenti: "Allegati già presenti",
    dimensione_file_non_valida: "Dimensione file non valida",
    tipologia_file_non_valida: "Tipologia file non valida",
    impossibile_recuperare_nuovo_elemento: "Impossibile recuperare il nuovo elemento dal database",
    banca_ore_rimanente: "Banca ore rimanente",
    categoria_permesso: "Tipologia di permesso",
    allegati: "Allegati",
    dati_permesso: "Dati permesso",
    sigla: "sigla",
    menu_statistiche: "Statistiche",
    dati_turno: "Dati turno",
    inizio_turno: "Inizio turno",
    inizio_turno_non_valido: "Inizio turno non valido",
    fine_turno_non_valido: "Fine turno non valido",
    fine_turno: "Fine turno",
    seleziona_stato: "Seleziona stato",
    dati_base: "Dati base",
    configurazione_base: "Configurazione base",
    dati_aggiuntivi: "Dati aggiuntivi",
    anteprima: "Anteprima",
    carica_immagine: "Carica immagine",
    rimuovi_immagine: "Rimuovi immagine",
    tema_chiaro: "Tema chiaro",
    tema_scuro: "Tema scuro",
    visualizza_anteprima: "Visualizza anteprima",
    anteprima_kiosk: "Anteprima Kiosk",
    spiegazione_anteprima_kiosk: "Visualizza come apparir\xE0 il Kiosk senza salvare le modifiche.",
    anteprima_area_camera: "Area camera",
    anteprima_descrizione: "Questa \xE8 solo una simulazione del layout del Kiosk. La telecamera, il QR code e le presenze non sono attive.",
    modalita_anteprima: "Modalit\xE0 anteprima",
    preview_non_trovata: "Anteprima non trovata o scaduta",
    preview_non_disponibile: "Impossibile generare l'anteprima",
    visualizza_qr_code_fullscreen: "Visualizza QR Code a schermo intero",
    mansione: "Mansione",
    straordinari_abilitati: "Abilita straordinari",
    durata_massima_straordinario_giornaliero: "Durata massima straordinario giornaliero",
    banca_ore_massimo: "Massimo banca ore",
    banca_ore_incremento: "Incremento periodico",
    banca_ore_periodo_incremento: "Periodicità incremento",
    in_attesa: "In attesa",
    approvato: "Approvato",
    rifiutato: "Rifiutato",
    utente_conferma: "Utente conferma",
    data_conferma: "Data conferma",
    banca_ore_attuale: "Saldo banca ore",
    banca_ore: "Banca ore",
    mostra_straordinario_banca_ore: "Mostra straordinario convertibile in banca ore",
    mostra_straordinario_banca_ore_help:
      "Nelle dashboard mostra le ore di straordinario del mese corrente e del precedente (se non validato) convertibili in banca ore",
    straord_mese_corrente: "Straord. mese corrente",
    straord_mese_precedente: "Straord. mese precedente",
    ore_disponibili_banca_ore: "Ore banca disponibili",
    abilita_banca_ore: "Abilita banca ore",
    conversione_straordinari_banca_ore: "Conversione straordinari in banca ore",
    messaggio_straordinari_banca_ore: "Nel mese sono presenti {ore} ore di straordinario.",
    saldo_attuale_banca_ore: "Saldo attuale banca ore",
    domanda_conversione_straordinari: "Vuoi convertire le ore di straordinario in banca ore?",
    no_mantieni_straordinari: "No, mantieni straordinari",
    si_rimuovi_straordinari: "Sì, rimuovi straordinari dal mese",
    si_mantieni_straordinari: "Sì, mantieni straordinari nel mese",
    conversione_straordinari_successo: "Ore di straordinario convertite in banca ore con successo",
    salva_modifiche_mese: "Salva modifiche mese",
    conferma_salvataggio_modifiche_mese: "Sei sicuro di voler salvare tutte le modifiche apportate al mese?",
    salvataggio_modifiche_mese_successo: "Modifiche del mese salvate con successo",
    preferenze: "Preferenze",
    preferenze_descrizione: "Personalizza il comportamento dell'applicazione",
    preferenze_aggiornate: "Preferenze aggiornate",
    salvataggio_resoconto_manuale: "Salvataggio manuale nel resoconto presenze",
    salvataggio_resoconto_manuale_descrizione:
      "Se attivo, le modifiche fatte nella tabella del resoconto non vengono salvate subito ma solo quando premi \"Salva modifiche\".",
    salvataggio_manuale_attivo: "Salvataggio manuale attivo: le modifiche vengono salvate solo con \"Salva modifiche\"",
    annulla_modifiche: "Annulla modifiche",
    scarta_modifiche: "Scarta modifiche",
    conferma_annulla_modifiche_resoconto: "Vuoi annullare tutte le modifiche non salvate del tabellone?",
    salva_o_annulla_modifiche_resoconto: "Salva o annulla prima le modifiche in sospeso del tabellone.",
    conferma_salva_modifiche_contesto_precedente:
      "Hai lasciato modifiche non salvate sul resoconto precedente. Vuoi salvarle?",
    conferma_uscita_modifiche_non_salvate: "Ci sono modifiche non ancora salvate nel resoconto. Vuoi salvarle prima di uscire?",
    giorni_modificati_non_salvati: "Giorni modificati: {n}",
    resta_nella_pagina: "Resta nella pagina",
    esci_senza_salvare: "Esci senza salvare",
    salva_ed_esci: "Salva ed esci",
    continua_a_modificare: "Continua a modificare",
    conferma_cambio_contesto_modifiche_non_salvate:
      "Ci sono modifiche non ancora salvate nel resoconto. Salvale o annullale prima di cambiare.",
    salva_o_annulla_modifiche_giorno: "Salva o annulla prima le modifiche in sospeso di questo giorno.",
    menu_pianificazione_turni: "Pianificazione turni",
    error_suggerimento: "Se il problema persiste, contatta il supporto o riprova più tardi",
    rimuovi_preferito: "Rimuovi dai preferiti",
    apri_popup_esterno: "Apri popup esterno",
    successo: "Successo",
    favorite_page_pagina_aggiunta: "Pagina aggiunta ai preferiti",
    favorite_page_pagina_rimossa: "Pagina rimossa dai preferiti",
    profilo: "Profilo",
    aggiorna_le_tue_informazioni: "Aggiorna le tue informazioni personali",
    aggiorna_la_tua_password: "Aggiorna la tua password di accesso",
    proteggi_il_tuo_account: "Proteggi il tuo account con l'autenticazione a due fattori",
    documenti_personali: "Documenti personali",
    documenti_personali_descrizione: "Documenti caricati dall'amministrazione",
    visualizza_immagine_profilo: "Visualizza immagine profilo",
    cambia_immagine_profilo: "Cambia immagine profilo",
    rimuovi_immagine_profilo: "Rimuovi immagine profilo",
    foto_profilo_rimossa: "Foto profilo rimossa con successo",
    cerca_documento: "Cerca documento...",
    filtra_tipologia: "Filtra per tipologia",
    tipologie_selezionate: "tipologie selezionate",
    raggruppa_per_mese: "Raggruppa per mese",
    raggruppa_per_tipologia: "Raggruppa per tipologia",
    raggruppa_per_documento: "Raggruppa per documento",
    nessun_risultato_filtri: "Nessun documento corrisponde ai filtri selezionati",
    senza_titolo: "Senza titolo",
    data_sconosciuta: "Data sconosciuta",
    menu_bacheca: "Bacheca",
    impostazioni_turno: "Impostazioni turno",
    menu_configura_orari: "Configura orari",
    conferma_archivia: "Sei sicuro di voler archiviare gli elementi selezionati?",
    conferma_archivia_aziende:
      "Archiviando, nessun utente di queste aziende potrà più accedere, né dall'app né dal kiosk, finché non le ripristini. I dati restano salvati. Chi lavora anche per altre aziende continuerà ad accedere a quelle. Continuare?",
    conferma_ripristina_aziende:
      "Ripristinando, gli utenti di queste aziende torneranno ad accedere come prima dell'archiviazione. Continuare?",
    mostra_archiviate: "Mostra archiviate",
    mostra_nascondi_linee_griglia: "Mostra/Nascondi linee griglia",
    mostra_linee_griglia: "Mostra linee griglia",
    nascondi_linee_griglia: "Nascondi linee griglia",
    manca_id_elemento: "Manca l'ID dell'elemento",
    pec_non_valida: "PEC non valida",
    codice_fiscale_non_valido: "Codice fiscale non valido",
    dati_aziendali: "Dati aziendali",
    contatti: "Contatti",
    sede: "Sede",
    qr_code: "QR Code",
    disabilitato: "Disabilitato",
    abilitato: "Abilitato",
    facoltativo: "Facoltativo",
    con_reperibilità: "Con reperibilità",
    orari: "Orari",
    pause_retribuite: "Pause retribuite",
    ore_pausa_fuori_turno: "Ore di pausa libere",
    pause_retribuite_fuori_turno: "Pause retribuite",
    ore_per_giornata: "Ore lavorative",
    orario: "Orario",
    seleziona_un_gruppo_per_importazione: "Seleziona un gruppo per l'importazione",
    importazione_dati_gruppo_completata: "Importazione dati gruppo completata",
    importa_dati_gruppo: "Importa dati dal gruppo",
    gruppo_appartenenza: "Gruppo di appartenenza",
    gruppo: "Gruppo",
    non_attivo: "Non attivo",
    attivo: "Attivo",
    nessun_file: "Nessun file selezionato",
    posizioni_bollature: "Posizioni bollature",
    kiosk: "Kiosk",
    ore_approssimate: "Ore lavorate",
    ore_straordinari: "Ore straordinari",
    ore_permesso: "Ore permesso",
    ore_ferie: "Ore ferie",
    ore_malattia: "Ore malattia",
    // Bottone del selettore delle ore nel resoconto (app/utils/bottoneOre.js)
    un_ora: "1 ora",
    inizia_tour_guidato: "Inizia il tour guidato",
    tipo_contratto: "Tipo contratto",
    tipo_turno: "Tipo turno",
    menu_calendario: "Calendario",
    menu_risorse: "Risorse",
    abilita_bollatura_remota: "Abilita rilevazione presenze remota",
    abilita_rilevazione_presenza_remota: "Abilita rilevazione presenze remota",
    abilita_bollatura: "Abilita rilevazione presenze",
    impostazioni_rilevamento_presenze: "Impostazioni rilevazione presenze",
    menu_bollatura_remota: "Rilevazione presenze remota",
    generazione_pdf_in_corso: "Generazione PDF in corso...",
    esporta_pdf: "Esporta PDF",
    nessun_elemento_selezionato_per_esportazione: "Nessun elemento selezionato per l'esportazione",
    entrata_registrata: "Entrata registrata",
    uscita_registrata: "Uscita registrata",
    inizio_pausa_registrata: "Inizio pausa registrata",
    fine_pausa_registrata: "Fine pausa registrata",
    errore_connessione: "Il kiosk non raggiunge il server. Riprova tra poco.",
    dati_anagrafici: "Dati anagrafici",
    codice_univoco: "Codice univoco",
    dimensione_testo: "Dimensione testo",
    install_pwa: {
      title: "Installa l’app",
      subtitle: "Scarica la nostra web app per un’esperienza più veloce e comoda",
      follow_guide: "Segui la guida qui sotto",
      install_now: "Installa ora",
      close: "Chiudi",
      close_and_dont_show: "Chiudi e non mostrare più",

      login_auto: {
        title: "Login automatico",
        step1: "Installando la PWA, la sessione sarà riconosciuta",
        step2: "Non servirà accedere di nuovo",
        step3: "L'app ti autenticherà ogni volta che la apri",
      },

      desktop: {
        title: "Desktop",
        step1: "Apri questo sito su Chrome o Edge.",
        step2: "Clicca sull’icona <i class='fas fa-display-arrow-down'></i> nella barra degli indirizzi.",
        step3: "Conferma su “Installa”.",
      },

      android: {
        title: "Android",
        step1: "Apri il sito su Chrome.",
        step2: "Tocca il menu <i class='fas fa-ellipsis-vertical'></i>.",
        step3: "Seleziona “Aggiungi a schermata Home”.",
        step4: "Conferma su “Installa”.",
      },

      ios: {
        title: "iOS",
        step1: "Apri il sito in Safari.",
        step2: "Tocca <i class='fas fa-arrow-up-from-square'></i>.",
        step3: "Seleziona “Aggiungi alla schermata Home”.",
        step4: "Conferma su “Aggiungi”.",
      },
    },
    totale_elementi: "Totale elementi",
    comune_nascita: "Comune di nascita",
    dati_bancari: "Dati bancari",
    dati_personali: "Dati personali",
    seleziona_azienda: "Seleziona azienda",
    ragione_sociale: "Ragione Sociale",
    dati_accesso: "Dati di accesso",
    domicilio_residenza: "Domicilio/Residenza",
    selezionati: "Selezionati",
    pagina: "Pagina",
    risultati: "Risultati",
    cognome: "Cognome",
    nome: "Nome",
    creato: "Creato",
    modificato: "Modificato",
    ultima_modifica: "Ultima modifica",
    super_amministratore: "Super Amministratore",
    password_non_valida: "La password deve contenere almeno 12 caratteri, una lettera maiuscola, una minuscola, un numero e un carattere speciale",
    errore: "Errore",
    minimo_12_caratteri: "Minimo 12 caratteri richiesti",
    cambia_colore_riga: "Cambia colore riga",
    minimo_3_caratteri: "Minimo 3 caratteri richiesti",
    partita_iva_non_valida: "Partita IVA non valida",
    aggiungi_preferito: "Aggiungi ai preferiti",
    apri_popup_esterno: "Apri popup esterno",
    regione: "Regione",
    localita: "Località",
    nazione: "Nazione",
    provincia: "Provincia",
    referente: "Referente",
    menu_permessi: "Permessi",
    menu_resoconto: "Resoconto",
    menu_categorie: "Tipologie e abilitazioni",
    menu_rilevazione_presenze: "Resoconto presenze",
    // Guide in app (menu e bottone «Guida» nella testata delle pagine che ne hanno una).
    menu_guide: "Guide",
    menu_guida_resoconto: "Resoconto presenze",
    menu_guida_risorse: "Anagrafica risorse",
    menu_guida_gruppi: "Gruppi",
    menu_guida_orari: "Orari di lavoro",
    menu_guida_ferie_permessi: "Ferie e permessi",
    menu_guida_impostazioni: "Impostazioni aziendali",
    menu_guida_note_spese: "Note spese",
    guida_pagina: "Guida di questa pagina",
    guida_salva_prima:
      "Salva le modifiche prima di aprire la guida: aprendola le assegnazioni non salvate andrebbero perse.",
    menu_aziende: "Aziende",
    progetto_aggiornato: "Il progetto è stato aggiornato!",
    testo_aggiornamento_app: "Per continuare, puoi ricaricare la pagina oppure reinstallare la PWA",
    descrizione_orario_turno_rotazione: "Inserire ora di inizio e di fine turno",
    descrizione_orario_turno_fisso: "Inserire ora di inizio e di fine turno",
    info_tipologia_orario_turno:
      "Il tipo del turno stabilisce come vengono calcolate le ore di lavoro e in che modo il turno viene assegnato se si sceglie di assegnare i turni automaticamente.",
    durata_turno: "Durata turno",
    tipo_orario_turno: "Tipo orario turno",
    info_durata_turno:
      "La durata del turno serve a stabilire quante ore di lavoro il dipendente deve raggiungere in questo turno.sono escluse le ore di pausa non retribuite.",
    descrizione_orario_turno_selezionato: "Inserire ora di inizio e di fine turno",
    orario_turno: "Orario del turno",
    descrizione_orario_turno: "Descrizione orario del turno",
    descrizione_orario_turno_libero:
      "Questo turno può iniziare e finire in qualsiasi momento della giornata, ma devono essere lavorate un totale di {ore} ore.",
    info_nome_turni:
      "Il nome del turno deve essere univoco e facilmente identificabile. Viene utilizzato per rappresentare il turno nelle varie visualizzazioni,ricerca e report.",
    info_sigla_turni:
      "La sigla del turno viene utilizzata per abbreviare il suo nome e renderlo riconoscibile nelle modalità di visualizzazione in cui lo spazio è limitato, come le tabelle e le estrazioni, questa deve essere univoca.",
    inizio: "Inizio",
    fine: "Fine",
    durata: "Durata",
    info_nome_gruppi:
      "Nel campo 'Nome' deve essere inserito il nome che si vuole assegnare al gruppo che si sta creando. Il nome si trova nella tabella dei dipendenti, nella sezione 'Dipendenti', nella sezione 'Gruppi', cliccando su 'PRESENZE GRUPPO' e nella sezione 'Calendario', dove è presente un sistema che filtra per il calendario in base al gruppo selezionato.Selezionare un colore aiuta a identificare più facilmente il gruppo all'interno dell'applicazione.",
    menu_turni: "Turni",
    menu_impostazioni: "Impostazioni",
    turni_assegnati: "Turni assegnati",
    info_turni_assegnati:
      "Nel campo 'Turni Assegnati' si devono inserire i turni che è possibile assegnare ai membri del gruppo che si sta creando, spuntando le caselle vicino ai turni interessati. Il primo pulsante a destra del campo permette di filtrare i turni per trovarli più facilmente; il secondo pulsante permette di resettare questi filtri. I turni assegnati al gruppo si trovano nella sezione 'Gruppi' della barra laterale, cliccando su 'PRESENZE MEMBRI'.",
    info_bollatura_attiva:
      "Spuntando la casella 'Rilevazione presenze attiva' i membri del gruppo sono abilitati a timbrare al chiosco. Si può verificare se questo campo è spuntato, nella sezione 'Gruppi' della barra laterale, cliccando sul gruppo interessato e cliccando su 'PRESENZE MEMBRI'.",
    info_bollatura_remota_attiva:
      "Spuntando la casella 'Rilevazione presenze remota attiva' i membri del gruppo sono abilitati a timbrare remotamente, tramite l'app, fornendo le coordinate GPS. Si può verificare se questo campo è spuntato, nella sezione 'Gruppi' della barra laterale, cliccando sul gruppo interessato e cliccando su 'PRESENZE MEMBRI'.",
    turni_info:
      "Nel campo 'Giorni lavorativi' si devono inserire i giorni in cui è possibile assegnare turni ai membri del gruppo che si sta creando, spuntando una casella per ogni giorno lavorativo.\nI giorni lavorativi del gruppo si trovano nella sezione 'Gruppi' della barra laterale, cliccando su 'PRESENZE  MEMBRI'.",
    presenze_membri: "Presenze membri",
    nome_gruppo_esistente: "Nome gruppo già esistente nel database",
    errore_creazione_gruppo: "Errore durante la creazione del gruppo",
    errore_aggiornamento_gruppo: "Errore durante l'aggiornamento del gruppo",
    gruppo_creato: "Gruppo creato con successo!",
    gruppo_aggiornato: "Gruppo aggiornato con successo!",
    turni: "Turni",
    rilevazioni_presenze: "Rilevazioni presenze",
    giorni_lavorativi: "Giorni lavorativi",
    dispositivo_di_sicurezza: "Dispositivo di sicurezza",
    telefono_non_valido: "Telefono non valido",
    email_non_valida: "Email non valida",
    bollatura_attiva: "Rilevazione presenze attiva",
    bollatura_remota_attiva: "Rilevazione presenze remota attiva",
    richiesta_permesso_nuovo: "Richiesta permesso nuovo",
    richiesta_permesso_modificato: "Richiesta permesso modificato",
    richiesta_nota_spesa_nuova: "Richiesta nota spesa nuova",
    richiesta_nota_spesa_aggiornata: "Richiesta nota spesa aggiornata",
    licenza_non_valida: "Licenza non valida",
    aborto: "Aborto",
    quanti_aborti: "Quanti aborti",
    tipologia_transazione: "Tipologia transazione",
    giftcard: "Giftcard",
    firma_non_presente: "Firma non presente",
    menu_dipendenti: "Risorse",
    credito_attuale: "Credito attuale",
    aggiunta: "Aggiunta",
    sottrazione: "Sottrazione",
    credito_residuo_dopo_operazione: "Credito residuo dopo operazione",
    calcolo_automatico_del_nuovo_saldo: "Calcolo automatico del nuovo saldo",
    paese_nascita: "Comune di nascita",
    campo_obbligatorio: "Campo obbligatorio",
    importo: "Importo",
    conferma_inserimento_transazione: "Conferma inserimento transazione",
    saldo_pre_transazione: "Saldo pre-transazione",
    saldo_post_transazione: "Saldo post-transazione",
    resoconto_transazioni: "Resoconto transazioni",
    aggiungi_transazione: "Aggiungi transazione",
    registra_firma: "Registra firma",
    attendendo_firma_dispositivo: "Attendere firma dispositivo...",
    cambia_firma: "Cambia firma",
    nessuna_transazione: "Nessuna transazione",
    nessuna_transazione_giftcard_registrata: "Nessuna transazione giftcard registrata",
    inserimento_eseguito: "Inserimento eseguito con successo!",
    stampa: "Stampa",
    menu_gruppi: "Gruppi",
    tipo: "Tipo",
    medici: "Medici",
    residenza: "Residenza",
    importa_excel: "Importa Excel",
    elenco_specialisti: "Elenco Specialisti",
    menu_elenco_specialisti: "Elenco Specialisti",
    salva_appuntamento: "Salva Appuntamento",
    crea_referto: "Crea Referto",
    aggiunto: "Aggiunto",
    vai_ad_oggi: "Vai ad Oggi",
    ricarica_eventi: "Ricarica Eventi",
    calendario: "Calendario",
    a: "a",
    aggiungi: "Aggiungi",
    aggiungi_note: "Aggiungi note",
    aggiorna: "Aggiorna",
    aggiorna_tabella: "Aggiorna la tabella",
    anno: "Anno",
    annulla: "Annulla",
    annulla_modifica: "Annulla modifica",
    autenticazione_2FA: "Autenticazione 2FA",
    biometria_non_disponibile: "Biometria non disponibile su questo dispositivo",
    biometria_apertura: "Richiedi Face ID / impronta all'apertura",
    biometria_anche_al_rientro: "Anche quando torni nell'app dopo 5 minuti",
    biometria_obbligatoria_amministratori: "Obbligatorio per chi amministra l'azienda",
    biometria_proposta_titolo: "Sblocco con Face ID / impronta",
    biometria_proposta_testo: "Vuoi che ToDo-E chieda Face ID o l'impronta quando lo apri? Così nessun altro può entrare dal tuo telefono. Puoi cambiare idea dal Profilo.",
    biometria_proposta_obbligatoria: "Chi amministra l'azienda vede dati riservati: per questo ToDo-E chiede Face ID o l'impronta quando lo apri e quando ci torni dopo 5 minuti.",
    biometria_proposta_attiva: "Attiva",
    biometria_proposta_continua: "Continua",
    biometria_proposta_no: "Non ora",
    azioni: "Azioni",
    benvenuto_descrizione: "Gestione e pianificazione commesse",
    benvenuto_titolo: "TODOE",
    benvenuto_utente: "Benvenuto",
    recapito_emergenza: "Contatto d'emergenza",
    calcola_data_fine: "Calcola data fine stimata",
    calendario: "Calendario",
    cambia_immagine: "Cambia immagine",
    cambia_password: "Cambia password",
    cambia_tema: "Cambia tema",
    cambio_lingua: "CAMBIO LINGUA IN CORSO...",
    campo_richiesto: "Campo richiesto",
    caricamento_dati: "Caricamento dei dati in corso...",
    categorie: "Categorie",
    categoria: "Categoria",
    cerca: "Cerca...",
    prezzo_lordo: "Prezzo Lordo",
    prezzo_di_acquisto: "Prezzo di Acquisto",
    extra: "Extra",
    paziente: "Paziente",
    registra_nuovo_paziente: "Registra nuovo paziente",
    ora: "Ora",
    medico: "Medico",
    struttura: "Struttura",
    tipologia_visita: "Tipologia Visita",
    data_creazione: "Data Creazione",
    data_creazione: "Data Creazione",
    prezzo_lordo: "Prezzo Lordo",
    udm: "Unità di Misura",
    chiudi: "Chiudi",
    cliente: "Cliente",
    codice: "Codice",
    codice_email: "Codice via email",
    partita_iva: "Partita IVA",
    codice_sdi: "Codice SDI",
    pec: "PEC",
    peso: "Peso",
    attuale_peso: "Attuale Peso",
    altezza: "Altezza",
    altezza_precisa: "Altezza in cm",
    circonferenza_polso: "Circonferenza polso in cm",
    circonferenza_addome: "Circonferenza addome in cm",
    gruppo_sanguigno: "Gruppo sanguigno",
    sport: "Fai sport",
    sport_quali: "Quali sport?",
    sport_frequenza: "Frequenza sportiva",
    regime_alimentare: "Regime alimentare",
    regime_alimentare_altro: "Altro regime alimentare",
    alimentazione_e_idratazione: "Alimentazione e idratazione",
    rapporto_corpo_desc: "Hai un buon rapporto con il tuo corpo?",
    rapporto_corpo: "Rapporto con il corpo",
    capelli_desc: "I capelli hanno subito trattamento colorante, tinta, altro?",
    capelli_descrizione: "Descrizione trattamento capelli",
    acqua: "Acqua",
    iban: "IBAN",
    bic_swift: "BIC/SWIFT",
    nominativo_conto: "Nominativo conto",
    rs_banca: "Banca",
    paese_banca: "Filiale banca",
    codice_abi: "Codice ABI",
    iban_valido: "IBAN valido",
    iban_non_valido: "L\'IBAN immesso sembra non essere valido. Controlla di averlo inserito correttamente.",
    banca_rilevata: "Banca rilevata automaticamente",
    banca_non_trovata: "Banca non trovata per questo IBAN",
    verifica_iban: "Verifica IBAN",
    validazione_iban_in_corso: "Validazione IBAN in corso...",
    codice_autenticazione: "Codice di autenticazione",
    codice_inviato: "Codice inviato! Controlla la tua email per continuare.",
    codice_obbligatorio: "Il codice è obbligatorio!",
    codice_recupera_password_verificato: "Codice verificato correttamente, procedi con l'inserimento della nuova password",
    codice_testo: "Inserisci il codice che ti è stato inviato tramite e-mail prima della scadenza del tempo",
    cognome: "Cognome",
    colore: "Colore",
    commessa: "Commessa",
    esporta_excel: "Esporta excel",
    transazioni_disponibili_dopo_creazione: "Le transazioni risulteranno disponibili dopo la creazione",
    inserisci_saldo_iniziale_o_lascia_vuoto: "Al momento, inserisci il saldo iniziale del paziente oppure lascia vuoto per impostare €0,00",
    commessa_duplicata: "Commessa duplicata con successo!",
    commessa_eliminata: "Commessa eliminata con successo!",
    commessa_ricevuta: "Commessa ricevuta",
    commessa_risorsa_aggiornata: "Commessa aggiornata con successo!",
    commesse_importate: "Commesse importate con successo",
    concludi: "Concludi",
    conferma: "Conferma",
    conferma_eliminazione: "Sicuro di voler eliminare i dati selezionati?",
    conferma_eliminazione_transazione:
      "Sicuro di voler eliminare la transazione? Così facendo verrà solamente eliminata la transazione, il credito residuo non verrà modificato.",
    costo_finale: "Costo finale",
    crea: "Crea",
    creatoIl: "Creato il",
    creazione_eseguita: "Creazione eseguita con successo!",
    date_non_disponibili: "Le date scelte cadono nel periodo bloccato «{motivo}».",
    date_non_disponibili_header: "Date non disponibili",
    conferma_split_richieste:
      "Alcune date del periodo selezionato non sono disponibili. La richiesta verrà suddivisa in {count} richieste distinte ({segmenti}). Procedere?",
    conferma_riduzione_richiesta:
      "Alcune date del periodo selezionato non sono disponibili. La richiesta verrà ridotta a {segmenti}. Procedere?",
    richieste_create_count: "Operazione completata: {count} richieste create.",
    // Periodi bloccati nella richiesta (spec 2026-10-09 periodi-bloccati §5, §10)
    periodi_per_tipologia: "Periodi per questa tipologia",
    periodo_riga: "{motivo}: dal {inizio} al {fine} · {effetto}",
    periodo_riga_bloccato: "Bloccato",
    periodo_riga_avviso: "Solo avviso",
    periodi_altri: "e altri {n}",
    periodo_motivo_vuoto: "Periodo bloccato",
    periodo_critico: "Periodo critico",
    periodo_critico_conferma:
      "Le date cadono nel periodo «{motivo}» (dal {inizio} al {fine}). La richiesta parte lo stesso, ma chi la approva la vedrà segnalata. Vuoi inviarla?",
    data: "Data",
    data_fine: "Data fine",
    data_fine_maggiore_data_inizio: "La data di fine deve essere maggiore della data di inizio",
    data_fine_stimata: "Data fine stimata",
    data_inizio: "Data inizio",
    data_intervento: "Data intervento",
    data_nascita: "Data di nascita",
    luogo_nascita: "Luogo di nascita",
    provincia_nascita: "Provincia di nascita",
    stato_nascita: "Paese di nascita",
    data_ultimo_login: "Ultimo login",
    dati_non_disponibili: "Dati non disponibili",
    dati_personali: "Dati personali",
    da_pianificare: "Da pianificare",
    denominazione: "Denominazione",
    descrizione: "Descrizione",
    dettagli_base: "Dettagli base",
    di: "di",
    dipendente_cliente: "Risorsa cliente",
    durata_attuale: "Ore attuali",
    durata_giornata_lavorativa: "Durata giornata lavorativa",
    durata_prevista: "Ore previste",
    duplica_commessa: "Duplica commessa",
    esporta: "Esporta",
    email: "Email",
    emailResetPassInviata: "Email per reset password inviata all'utente specificato.",
    email_cliente: "Email cliente",
    email_invio_rapportino: "Email invio rapportino",
    archivia: "Archivia",
    elimina_commessa: "Elimina commessa",
    errore: "Errore!",
    errore_generazione_qr: "Errore generazione QR!",
    error_effettua_login: "Effettua il login per continuare",
    sessione_scaduta: "La sessione non è più valida: accedi di nuovo.",
    error_sottotitolo_401:
      "<span>Ci dispiace, ma non hai i permessi necessari per completare l'operazione. <br/>Riprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione. <br/>Grazie per la tua comprensione e pazienza.</span>",
    error_sottotitolo_404:
      "<span>Ci scusiamo, ma la pagina che stai cercando non è disponibile o è stata spostata. <br/>Verifica l'URL e assicurati che sia corretto. <br/>Se il problema persiste, potrebbe essere dovuto a un link obsoleto o a una risorsa eliminata.</span>",
    error_sottotitolo_generale:
      "<span>Ci dispiace, si è verificato un errore imprevisto durante l'operazione. <br/>Riprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione. <br/>Grazie per la tua comprensione e pazienza.</span>",
    error_titolo_401: "Non autorizzato",
    error_titolo_404: "Pagina non trovata",
    error_titolo_generale: "Errore riscontrato",
    error_torna_pagina_iniziale: "Torna alla pagina iniziale",
    favorite_page_pagina_rimossa: "Pagina rimossa dai preferiti",
    ferma_timer: "Ferma timer",
    file_e_documenti: "File e documenti",
    file_troppo_grande: "File troppo grande",
    fornitura: "Fornitura",
    genera_password: "Genera password",
    genera_qr: "Genera QR",
    gestione_orari: "Gestione orari",
    grafico: "Grafico",
    id: "ID",
    immagine_profilo: "Immagine profilo",
    immagine_profilo_aggiornata: "Immagine profilo aggiornata con successo!",
    importa: "Importa",
    inattivita_descrizione_1: "È stata rilevata un'inattività prolungata.",
    inattivita_descrizione_2: "Per motivi di sicurezza sei stato disconnesso.",
    inattivita_titolo: "Inattività rilevata!",
    indirizzo_ip: "Indirizzo IP",
    indirizzo_luogo_intervento: "Indirizzo luogo intervento",
    informazione: "Informazione",
    inserisci_mail_valida: "Inserisci una mail valida",
    invia_credenziali: "Invia credenziali tramite e-mail",
    invia_file: "Invia file",
    invia_rapportino: "Invia rapportino",
    inviata_amministrazione: "Inviata all'amministrazione",
    inviata_cliente: "Inviata al cliente",
    livello: "Livello",
    lista: "Lista",
    totale_risorse: "Totale Risorse",
    completa_profilo: "Completa tutti i campi per continuare",
    login_aggiorna_accedi: "Aggiorna e accedi",
    login_attendi: "Attendi...",
    login_attendi_riprova: "Attendi per riprovare!",
    login_benvenuto: "Benvenuto!",
    login_campo_non_sicuro: "Campo non sicuro!",
    login_campi_obbligatori: "Inserire sia username che password per continuare",
    login_codice_scaduto: "Codice scaduto! riprova per continuare",
    login_conferma_password: "Conferma password",
    login_nuova_password: "Nuova password",
    login_controlla_mail: "Controllare le email per continuare",
    login_effetta_accesso: "Effettua l'accesso",
    login_email_reset_pass_inviata: "Email per reset password inviata all'utente specificato.",
    login_livello_sicurezza_password: "Livello di sicurezza password",
    login_password: "Password",
    modifica_password: "Modifica Password",
    login_password_dimenticata: "Password dimenticata?",
    login_password_non_uguali: "Le password non corrispondono",
    login_reset_password: "Resetta la password",
    login_scegli_autenticazione: "Seleziona il metodo di autenticazione",
    login_submit_text: "Accedi",
    login_suggerimenti_password: "Suggerimenti password",
    login_suggerimenti_password_1: "La password deve contenere almeno una lettera minuscola",
    login_suggerimenti_password_2: "La password deve contenere almeno una lettera maiuscola",
    login_suggerimenti_password_3: "La password deve contenere almeno un numero",
    login_suggerimenti_password_4: "La password deve contenere almeno uno carattere speciale",
    login_suggerimenti_password_5: "La password deve contenere almeno 8 caratteri",
    login_timeout_codice: "Codice di verifica scaduto",
    login_troppe_richieste: "Hai effettuato troppe richieste!",
    login_usa_password: "Usa la tua password",
    login_username: "Username",
    login_username_reset_password: "Inserisci l'username per cui si vuole richiedere il reset password nel campo 'username'.",
    login_utente_non_trovato: "Impossibile trovare l'utente inserito!",
    logout_conferma_disconnessione: "Conferma",
    logout_disconnetti: "Disconnetti",
    logout_disconnessione: "Disconnessione",
    logout_messaggio_disconnessione: "Sicuro di voler effettuare la disconnessione?",
    luogo_intervento: "Luogo intervento",
    menu_amministratori: "Amministratori",
    menu_anagrafiche: "Anagrafiche",
    menu_categorie_commesse: "Categorie commesse",
    menu_tipologia_operatori: "Tipologia Operatori",
    menu_clienti: "Clienti",
    menu_appuntamenti: "Appuntamenti",
    menu_dashboard: "Dashboard",
    menu_strutture: "Strutture",
    menu_occupazione: "Occupazione",
    menu_priorita_commesse: "Priorità commesse",
    menu_prodotti: "Prodotti",
    menu_rapportini: "Rapportini",
    menu_rapportini_nuovo: "Crea nuovo",
    menu_rapportini_nuovo_rapportino: "Nuovo rapportino",
    menu_rapportini_resoconto: "Resoconto",
    menu_macro_gruppi: "Macro Gruppi",
    menu_pazienti: "Pazienti",
    menu_sconti: "Sconti",
    menu_tag_commesse: "Tag commesse",
    menu_utilita_calendario_eventi: "Calendario eventi",
    menu_utilita: "Utilità",
    menu_utilita_archivio: "Archivio",
    menu_utilita_chat: "Chat",
    menu_utilita_log: "Log",
    messaggio_conferma_eliminazione_selezionati: "Dati eliminati con successo!",
    messaggio_conferma_ripristino_selezionati: "Dati ripristinati con successo!",
    messaggio_duplicazione: "Duplicare la commessa?",
    messaggio_eliminazione: "Eliminare la commessa?",
    messaggio_eliminazione_selezionati: "Sicuro di voler eliminare i dati selezionati?",
    messaggio_ripristina_selezionati: "Sicuro di voler ripristinare i dati selezionati?",
    abitudini_vita: "Abitudini di vita",
    messaggio_eliminato: "Messaggio eliminato",
    dieta_libera_varia: "Dieta libera e varia",
    dieta_controllata: "Controllata per",
    digestione: "Digestione regolare",
    medico_curante: "Medico curante",
    storia_malattie_paziente: "Storia delle malattie del paziente",
    malattie_cuore: "Malattie del cuore",
    malattie_cuore_descrizione: "Descrizione malattie del cuore",
    pressione: "Pressione",
    allergie: "Allergie",
    quali_allergie: "Quali allergie?",
    diabete: "Diabete",
    tipologia_diabete: "Tipologia diabete",
    epatite_virale: "Epatite virale",
    tipologia_epatite: "Tipologia epatite",
    conseguenze_particolari: "Conseguenze particolari in seguito all'assunzione di anestetici, antibiotici, analgesici o altri farmaci ?",
    esami_radiografici: "Esami radiografici",
    terapia_irradiante: "Terapia irradiante",
    esami_radiografici_descrizione: "Descrizione esami radiografici",
    terapia_irradiante_descrizione: "Descrizione terapia irradiante",
    malattie_gravi_interventi_chirurgici: "Malattie gravi e/o interventi chirurgici",
    malattie_gravi_interventi_chirurgici_descrizione: "Descrizione malattie gravi e/o interventi chirurgici",
    menu_tipologie_visite: "Tipologie visite",
    alvo: "Alvo regolare",
    per_uomini: "Per gli uomini",
    sonno: "Sonno regolare",
    seleziona_elementi_da_esportare: "Seleziona gli elementi da esportare",
    pdf_generato_correttamente: "PDF generato correttamente",
    fumo: "Fumo",
    fame_nervosa_desc: "Soffri di fame nervosa?",
    stitichezza_desc: "Soffri di stitichezza?",
    stitichezza: "Stitichezza",
    fame_nervosa: "Fame nervosa",
    tipo_acqua: "Tipo di acqua",
    litri_giorno: "Litri di acqua al giorno",
    andropausa: "Andropausa",
    andropausa_anni: "Anni di andropausa",
    seleziona_alimenti_preferiti: "Seleziona alimenti preferiti (possibili più scelte)",
    quanto_fumo: "Quantità giornaliera",
    tempo_fumo: "Da quanto tempo?",
    numero_caffe: "Numero di caffè giornalieri",
    caffe: "Caffè",
    alcol: "Alcolici",
    quali_alcol: "Quali alcolici?",
    farmaci: "Assume farmaci e/o droghe?",
    quali_farmaci: "Quali farmaci e/o droghe?",
    tempo_farmaci: "Da quanto tempo?",
    perche_farmaci: "Perché?",
    antitetanica: "Antitetanica",
    ultimo_antitetanica: "Data ultima somministrazione",
    professione: "Professione",
    per_donne: "Per le donne",
    menarca_anni: "Menarca",
    menarca_anni_testo: "Anni",
    modifica: "Modifica",
    mostra_dettagli: "Mostra dettagli",
    mostra_ore: "Visualizza il monte ore",
    nessuna_chat_selezionata: "Nessuna chat selezionata",
    nessun_dato: "Nessun dato presente",
    seleziona_anamnesi: "Seleziona anamnesi",
    chiudi_anamnesi: "Chiudi anamnesi",
    seleziona_icd9: "Seleziona ICD9",
    ICD9: "ICD9",
    anamnesi_salvata: "Anamnesi salvata con successo!",
    data_evento: "Data evento",
    appunti: "Appunti",
    familiare: "Familiare",
    seleziona_familiare: "Seleziona familiare",
    diagnosi: "Diagnosi",
    appunti: "Appunti",
    annotazioni: "Annotazioni",
    nessuna_email_cliente: "Nessuna email presente per il cliente selezionato",
    nessun_cliente_selezionato: "Nessun cliente selezionato",
    nessun_dato_archiviato: "Non è presente alcun dato contrassegnato come archiviato",
    nominativo: "Nominativo",
    nominativo_cliente: "Nominativo cliente",
    nominativo_dipendente: "Nominativo risorsa cliente",
    nome: "Nome",
    sesso: "Sesso",
    citta: "Città",
    frazione: "Frazione / Località",
    codice_fiscale: "Codice Fiscale",
    cap: "CAP",
    indirizzo: "Indirizzo",
    indirizzo: "Indirizzo",
    provincia: "Provincia",
    non_programmato: "Non programmato",
    note: "Note",
    note_amministrative: "Note amministrative",
    note_intervento: "Note intervento",
    numero: "Numero",
    numero_documento: "Numero documento",
    oggi: "Oggi",
    compila_tutti_i_campi_obbligatori: "Compila tutti i campi obbligatori",
    occupazione: "Occupazione",
    ore_effettive: "Ore effettive",
    ore_lavorate: "Ore lavorate",
    ore_lavorate_breve: "ore lav.",
    ore_lavorate_breve_header: "Ore lav.",
    ore_lavorate_effettive: "Ore lavorate effettive",
    ore_lavorate_effettive_breve_header: "Ore eff.",
    ore_viaggio: "Ore viaggio",
    modifica_referto: "Modifica referto",
    oppure: "oppure",
    parametri: "Parametri",
    genera_password: "Genera password",
    pdf_generato_con_successo: "PDF generato con successo",
    errore_generazione_pdf: "Errore durante la generazione del PDF",
    referto_aggiornato_con_successo: "Referto aggiornato con successo",
    errore_aggiornamento_referto: "Errore durante l'aggiornamento del referto",
    aggiorna_referto: "Aggiorna referto",
    cambia_password: "Cambia password",
    password: "Password",
    password_aggiornata: "Password aggiornata con successo!",
    password_cambiata: "Password cambiata con successo!",
    password_gia_usata: "La password è già stata utilizzata in precedenza! Inserirne un'altra per continuare.",
    percentuale_completamento: "Progresso",
    pianificazione: "Pianificazione",
    privacy_policy: `<h1>INFORMATIVA PER IL TRATTAMENTO DI DATI</h1>
                  <p>In questa pagina si descrivono le modalità di gestione del sito in riferimento al trattamento dei dati personali degli utenti che lo consultano, nonché modalità e finalità di trattamento dei dati personali.</p>
                  <p>Si tratta di un'informativa resa anche ai sensi dell'art.13-14 Reg.to UE 2016/679 a coloro che interagiscono con i servizi web accessibili per via telematica a partire dall'indirizzo.</p>
                  <p>L'informativa è resa solo per il sito in oggetto e non anche per altri siti Web eventualmente consultabili tramite i nostri links, di cui non è in alcun modo responsabile.</p>
                  <p>
                      Nella qualità di Titolare del trattamento dei Suoi dati personali, ai sensi e per gli effetti del Reg.to UE 2016/679 - GDPR, con la presente La informa che la citata normativa prevede la tutela degli interessati rispetto al
                      trattamento dei dati personali e che tale trattamento sarà improntato ai principi di correttezza, liceità, trasparenza e di tutela della Sua riservatezza e dei Suoi diritti.
                  </p>
                  <p>I Suoi dati personali verranno trattati in accordo alle disposizioni legislative della normativa sopra richiamata e degli obblighi di riservatezza ivi previsti.</p>
                  <h2>TIPI DI DATI TRATTATI</h2>
                  <h3>Dati di Navigazione</h3>
                  <p>
                      I sistemi informatici e le procedure software preposte al funzionamento di questo sito web acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di
                      comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate ad interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi,
                      permettere di
                              permettere di identificare gli utenti. In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito, gli indirizzi in notazione URI (Uniform Resource
                              Identifier) delle dipendenti richieste, l'orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal
                              server (buon fine, errore, ecc.) ed altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente. Questi dati sono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e per
                              controllarne il corretto funzionamento e vengono cancellati immediatamente dopo l'elaborazione. I dati potrebbero essere utilizzati per l'accertamento di responsabilità in caso di ipotetici reati informatici ai danni del sito.
                          </p>
                          <h3>Dati forniti volontariamente dall'utente</h3>
                          <p>
                              L'invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo sito, così come la compilazione dei form per l'invio di richieste specifiche comportano la successiva acquisizione dell'indirizzo del
                              mittente, necessario per rispondere alle richieste, nonché degli eventuali altri dati personali inseriti nella missiva o nel form.
                              <br />Specifiche informative di sintesi vengono riportate o visualizzate nelle pagine del sito predisposte per particolari servizi a richiesta.
                          </p>
                          <h2>CONSEGUENZE DEL RIFIUTO DI CONFERIMENTO DEI DATI</h2>
                          <p>
                              A parte quanto specificato per i dati di navigazione, l'utente è libero di fornire i dati personali riportati nei moduli di richiesta, di iscrizione a mailing list o comunque indicati in contatti per sollecitare l'invio di materiale
                              informativo, tecnico o commerciale o di altre comunicazioni. Il loro mancato conferimento può comportare l'impossibilità di ottenere quanto richiesto.
                          </p>
                          <h2>MODALITA'DEL TRATTAMENTO</h2>
                          <p>
                              I dati vengono trattati principalmente con strumenti elettronici e informatici e memorizzati sia su supporti informatici che su supporti cartacei che su ogni altro tipo di supporto idoneo, nel rispetto delle modalità di cui agli art.
                              6, 32 del GDPR e mediante l'adozione delle adeguate misure di sicurezza previste. per prevenire la perdita di dati, usi illeciti o non corretti ed accessi non autorizzati.
                          </p>
                          <p>
                              La informiamo che, per fornire un servizio completo il nostro portale potrebbe contenere link ad altri siti web, non gestiti da noi. Non siamo responsabili di errori, contenuti, cookies, pubblicazioni di contenuto morale illecito,
                              pubblicità, banner o files non conformi alle disposizioni normative vigenti e del rispetto della normativa Privacy da parte di siti da noi gestiti a cui si fa riferimento. Per migliorare il servizio offerto è gradita una immediata
                              segnalazione di malfunzionamenti, abusi o suggerimenti all'indirizzo di posta elettronica. I suoi dati saranno trattati unicamente da personale espressamente autorizzato dal Titolare.
                          </p>
                          <h2>FINALITA'DEL TRATTAMENTO</h2>
                          <p>
                              Il trattamento dei dati verrà effettuato per:
                              <br />- dare la possibilità di accedere alle sezioni pubbliche e/o riservate del sito; <br />- dare esecuzione all'attivazione e alla manutenzione di eventuali servizi sottoscritti on-line; <br />- eseguire gli obblighi previsti da
                              leggi o regolamenti; <br />- la tutela del Titolare in sede giudiziaria; <br />- inviare materiale informativo di natura commerciale o promozionale <br />- consentire il monitoraggio costante sull'efficacia del servizio proposto.
                          </p>
                          <h2>SOGGETTI A CUI POTRANNO ESSERE COMUNICATI I DATI PERSONALI</h2>
                          <p>
                              I dati personali relativi al trattamento in questione possono essere comunicati anche a soggetti a cui sia riconosciuta la facoltà di accedere ai Vostri dati personali da norme di legge o di normative secondarie e/o comunitarie.
                              Inoltre alcuni dati possono essere comunicati e diffusi agli operatori internet si avvale per la gestione dei propri domini. La diffusione dei dati raccolti non è prevista.
                          </p>
                          <h2>PERIODO DI CONSERVAZIONE DEI DATI</h2>
                          <p>
                              Le segnaliamo che, nel rispetto dei principi di liceità, limitazione delle finalità e minimizzazione dei dati, ai sensi dell'art. 5 del GDPR, il periodo di conservazione dei Suoi dati personali è pari ad anni 15. Alla scadenza del
                              suddetto periodo di conservazione, i dati personali verranno automaticamente cancellati.
                          </p>
                          <h2>DIRITTI DEGLI INTERESSATI</h2>
                          <p>Reg.to UE 2016/679: Art. 15, 16, 17, 18, 19, 20, 21, 22 - Diritti dell'Interessato</p>
                          <p>1. L'interessato ha diritto di ottenere la conferma dell'esistenza o meno di dati personali che lo riguardano, anche se non ancora registrati, e la loro comunicazione in forma intelligibile.</p>
                          <p>
                              2. L'interessato ha diritto di ottenere l'indicazione:
                              <br />a. dell'origine dei dati personali; <br />b. delle finalità e modalità del trattamento; <br />c. della logica applicata in caso di trattamento effettuato con l'ausilio di strumenti elettronici; <br />d. degli estremi
                              identificativi del titolare, dei responsabili e del rappresentante designato ai sensi dell'articolo 5, comma 2; <br />e. dei soggetti o delle categorie di soggetti ai quali i dati personali possono essere comunicati o che possono
                              venirne a conoscenza in qualità di rappresentante designato nel territorio dello Stato, di responsabili o incaricati.
                          </p>
                          <p>
                              3. L'interessato ha diritto di ottenere:
                              <br />a. l'aggiornamento, la rettificazione ovvero, quando vi ha interesse, l'integrazione dei dati; <br />b. la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di legge, compresi quelli
                              di cui non è necessaria la conservazione in relazione agli scopi per i quali i dati sono stati raccolti o successivamente trattati; <br />c. l'attestazione che le operazioni di cui alle lettere a) e b) sono state portate a conoscenza,
                              anche per quanto riguarda il loro contenuto, di coloro ai quali i dati sono stati comunicati o diffusi, eccettuato il caso in cui tale adempimento si rivela impossibile o comporta un impiego di mezzi <br />d. manifestamente
                              sproporzionato rispetto al diritto tutelato; <br />e. la portabilità dei dati.
                          </p>
                          <p>
                              4. L'interessato ha diritto di opporsi, in tutto o in parte:
                              <br />a. per motivi legittimi al trattamento dei dati personali che lo riguardano, ancorché pertinenti allo scopo della raccolta; <br />b. al trattamento di dati personali che lo riguardano a fini di invio di materiale pubblicitario o
                              di vendita diretta o per il compimento di ricerche di <br />c. mercato o di comunicazione commerciale
                          </p>
                          <p>
                              L'utente ha diritto di ottenere dal titolare la cancellazione (diritto all'oblio), la limitazione, l'aggiornamento, la rettificazione, la portabilità, l'opposizione al trattamento dei dati personali che La riguardano, nonché in
                              generale può esercitare tutti i diritti previsti dagli art. 15, 16, 17, 18, 19, 20, 21, 22 del GDPR.
                          </p>
                          <p>Per esercitare i diritti sopra elencati, l'interessato dovrà rivolgere richiesta scritta attraverso e-mail.</p>
                          <p></p>
                          <h2>COOKIES</h2>
                          <p>
                              Per cookies s'intende un elemento testuale che viene inserito nel disco fisso di un computer o altro dispositivo dal fornitore del servizio on line ai visitatori del sito internet . I cookie possono raccogliere informazioni sulle
                              abitudini dei visitatori circa l'utilizzo del suddetto sito Internet, registrando le attività del loro computer o di altro dispositivo riguardo il suddetto sito, per esempio quando si tratta di fare degli acquisti.
                          </p>
                          <h3>I COOKIES possono essere:</h3>
                          <h3>Cookie proprietari (anche detti di prima parte)</h3>
                          <p>I cookie proprietari sono cookie che vengono salvati direttamente nel computer o altro dispositivo. Possono includere cookie come quelli di sessione e i cookie persistenti (descritti oltre).</p>
                          <p>I cookie proprietari possono essere utilizzati per seguire i movimenti effettuati dal computer o altro dispositivo del visitatore consultando il sito, per esempio per scopi di analisi.</p>
                          <h3>Cookie di terze parti</h3>
                          <p>Non vengono memorizzati cookie di terze parti</p>
                          <h3>Cookie di sessione</h3>
                          <p>
                              La durata che intercorre tra il momento in cui si apre il browser Internet e il momento in cui lo si chiude si chiama sessione di navigazione. I cookie di sessione sono cookie memorizzati nel computer o altro dispositivo del
                              visitatore nel corso di una sessione di navigazione, ma che scadono e sono normalmente eliminati alla fine di una sessione di navigazione.
                          </p>
                          <h3>Cookie persistenti</h3>
                          <p>
                              I cookie persistenti sono cookie memorizzati nel computer o altro dispositivo del visitatore nel corso di una sessione di navigazione, ma che restano nel computer o altro dispositivo dopo la fine della suddetta sessione di navigazione
                              (es registrazione della password). I cookie persistenti permettono ai siti di riconoscere il computer o altro dispositivo del visitatore quando è utilizzato per accedere di nuovo a uno dei nostri siti, dopo la fine di una sessione di
                              navigazione e all'inizio di una nuova sessione di navigazione, essenzialmente per aiutare il visitatore a riconnettersi rapidamente al nostro sito.
                          </p>
                          <p>
                              Il presente sito, per ragioni strettamente tecniche, fa uso delle seguenti tipologie di cookies:
                              <br />- cookie tecnici e di sessione, ad esempio per evitare che - ove previsto - l'utente debba immettere più volte la password per accedere a sezioni riservate del sito, oppure per memorizzare la lingua preferita di navigazione, o
                              per memorizzare alcune caratteristiche tecniche del browser utilizzato per la navigazione (inclusa l'accettazione dei cookies).
                          </p>
                          <p>È possibile disattivare l'utilizzo dei cookies, ma scegliendo una tale opzione è probabile che il sito presenti dei malfunzionamenti, più o meno evidenti a seconda della sezione del sito che si intende visitare.</p>
                          <p>Per disattivare i cookies, a seconda del browser utilizzato, possiamo suggerire alcune guide (valide nel momento in cui questo documento è stato scritto).</p>
                          <h3>Chrome</h3>
                          <p>1. Eseguire il Browser Chrome</p>
                          <p>2. Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione</p>
                          <p>3. Selezionare Impostazioni</p>
                          <p>4. Fare clic su Mostra Impostazioni Avanzate</p>
                          <p>5. Nella sezione &ldquo;Privacy&rdquo; fare clic su bottone &ldquo;Impostazioni contenuti&ldquo;</p>
                          <p>6. Nella sezione &ldquo;Cookie&rdquo; è possibile modificare le seguenti impostazioni relative ai cookie:</p>
                          <ul>
                              <li>Consentire il salvataggio dei dati in locale</li>
                              <li>Modificare i dati locali solo fino alla chiusura del browser</li>
                              <li>Impedire ai siti di impostare i cookie</li>
                              <li>Bloccare i cookie di terze parti e i dati dei siti</li>
                              <li>Gestire le eccezioni per alcuni siti internet</li>
                              <li>Eliminazione di uno o tutti i cookie</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.google.com/accounts/answer/61416?hl=it" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Mozilla Firefox</h3>
                          <p>1. Eseguire il Browser Mozilla Firefox</p>
                          <p>2. Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione</p>
                          <p>3. Selezionare Opzioni</p>
                          <p>4. Seleziona il pannello Privacy</p>
                          <p>5. Fare clic su Mostra Impostazioni Avanzate</p>
                          <p>6. Nella sezione &ldquo;Privacy&rdquo; fare clic su bottone &ldquo;Impostazioni contenuti&ldquo;</p>
                          <p>7. Nella sezione &ldquo;Tracciamento&rdquo; è possibile modificare le seguenti impostazioni relative ai cookie:</p>
                          <ul>
                              <li>Richiedi ai siti di non effettuare alcun tracciamento</li>
                              <li>Comunica ai siti la disponibilità ad essere tracciato</li>
                              <li>Non comunicare alcuna preferenza relativa al tracciamento dei dati personali</li>
                          </ul>
                          <p>8. Dalla sezione &ldquo;Cronologia&rdquo; è possibile:</p>
                          <ul>
                              <li>
                                  Abilitando &ldquo;Utilizza impostazioni personalizzate&rdquo; selezionare di accettare i cookie di terze parti (sempre, dai siti più visitato o mai) e di conservarli per un periodo determinato (fino alla loro scadenza, alla
                                  chiusura di Firefox o di chiedere ogni volta)
                              </li>
                              <li>Rimuovere i singoli cookie immagazzinati</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Internet Explorer</h3>
                          <p>1. Eseguire il Browser Internet Explorer</p>
                          <p>2. Fare click sul pulsante Strumenti e scegliere Opzioni Internet</p>
                          <p>3. Fare click sulla scheda Privacy e nella sezione Impostazioni modificare il dispositivo di scorrimento in funzione dell'azione desiderata per i cookie:</p>
                          <ul>
                              <li>Bloccare tutti i cookie</li>
                              <li>Consentire tutti i cookie</li>
                              <li>
                                  Selezione dei siti da cui ottenere cookie: spostare il cursore in una posizione intermedia in modo da non bloccare o consentire tutti i cookie, premere quindi su Siti, nella casella Indirizzo Sito Web inserire un sito internet e
                                  quindi premere su Blocca o Consenti
                              </li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.microsoft.com/it-it/products/windows?os=windows-10" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Safari 6/7</h3>
                          <p>1. Eseguire il Browser Safari</p>
                          <p>2. Fare click su Safari, selezionare Preferenze e premere su Privacy</p>
                          <p>3. Nella sezione Blocca Cookie specificare come Safari deve accettare i cookie dai siti internet.</p>
                          <p>4. Per visionare quali siti hanno immagazzinato i cookie cliccare su Dettagli</p>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.apple.com/kb/PH17191?locale=en_US&amp;viewlocale=it_IT" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Safari iOS (dispositivi mobile)</h3>
                          <p>1. Eseguire il Browser Safari iOS</p>
                          <p>2. Tocca su Impostazioni e poi Safari</p>
                          <p>3. Tocca su Blocca Cookie e scegli tra le varie opzioni: &ldquo;Mai&rdquo;, &ldquo;Di terze parti e inserzionisti&rdquo; o &ldquo;Sempre&rdquo;</p>
                          <p>4. Per cancellare tutti i cookie immagazzinati da Safari, tocca su Impostazioni, poi su Safari e infine su Cancella Cookie e dati</p>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.apple.com/it-it/HT201265" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Opera</h3>
                          <p>1. Eseguire il Browser Opera</p>
                          <p>2. Fare click sul Preferenze poi su Avanzate e infine su Cookie</p>
                          <p>3. Selezionare una delle seguenti opzioni:</p>
                          <ul>
                              <li>Accetta tutti i cookie</li>
                              <li>Accetta i cookie solo dal sito che si visita: i cookie di terze parti e che vengono inviati da un dominio diverso da quello che si sta visitando verranno rifiutati</li>
                              <li>Non accettare mai i cookie: tutti i cookie non verranno mai salvati</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://www.opera.com/help/tutorials/security/privacy/" target="_blank">pagina dedicata</a>.
                          </p>
                          <p>
                              Se il programma che utilizzate per la navigazione sui siti internet non è tra quelli citati in precedenza, vi suggeriamo di utilizzare un motore di ricerca on line (google, yahoo, bing&hellip;) per capire come disattivare i cookies in
                              tale specifico browser.
                          </p>`,
    prodotti: "Prodotti",
    qrcode: "QR Code",
    prodotto: "Prodotto",
    prodotti_relativi_ordine: "Prodotti relativi all'ordine",
    prodotti_utilizzati: "Prodotti utilizzati",
    profilo_aggiornato: "Profilo aggiornato con successo!",
    profilo_personale: "Profilo personale",
    rapportini: "Rapportini",
    referti: "Referti",
    oggetto: "Oggetto",
    note_aggiuntive: "Note Aggiuntive",
    firma: "Firma",
    salva_bozza: "Salva Bozza",
    bozza: "Bozza",
    consegnato: "Consegnato",
    salva_referto: "Salva Referto",
    nuovo_referto: "Nuovo Referto",
    rapportino_inviato: "Rapportino inviato con successo!",
    rapportino_ricevuto: "Rapportino ricevuto",
    relazione_intervento: "Relazione intervento",
    resoconto: "Resoconto",
    riprendi_timer: "Riprendi timer",
    ripristina: "Ripristina",
    risorsa: "Risorsa",
    salva: "Salva",
    scorciatoia_ctrl_b: "Apri/chiudi menu: CTRL + B",
    seleziona: "Seleziona",
    seleziona_foto: "Seleziona foto",
    settimana: "Settimana",
    settimana_attuale: "Settimana attuale",
    standard: "Standard",
    stato: "Stato",
    su: "su",
    su_cosa_hai_lavorato: "Su cosa hai lavorato?",
    telefono: "Telefono",
    tempo_rimanente: "Tempo rimanente",
    termina_modifica: "Termina prima la modifica in corso!",
    testo_copiato: "Testo copiato negli appunti",
    titolo_cambio_password: "Cambio password",
    totale_ore: "Totale ore",
    trasferta: "Trasferta",
    tutti_i_campi_devono_essere_compilati: "Tutti i campi obbligatori devono essere compilati",
    url: "URL",
    username: "Username",
    utenti: "Utenti",
    verifica_campi: "Verifica i campi inseriti",
    visualizzi_da: "Visualizzi da",
    zero_ore_lavorate_breve: "0 ore lav.",
    dati_importati_con_successo: "Dati importati con successo",
    errore_importazione: "Errore durante l'importazione",
    formato_file_non_supportato: "Formato file non supportato",
    seleziona_file_excel: "Seleziona file Excel",
    anteprima_dati: "Anteprima dati",
    conferma_importazione: "Conferma importazione",
    pazienti_da_importare: "Pazienti da importare",
    pazienti_importati: "Pazienti importati",
    pazienti_aggiornati: "Pazienti aggiornati",
    processing_import: "Elaborazione importazione in corso...",
    file_non_valido: "File non valido",
    dati_non_validi: "Dati non validi nel file",
    conferma_creazione_commessa_con_padre:
      "Sei sicuro di voler creare una commessa figlia? Se la commessa padre ha una pianificazione, questa verrà eliminata.",
    utenti_in_carico: "Utenti in carico",
    lascia_incarico: "Lascia incarico",
    conferma_lascia_incarico: "Sei sicuro di voler lasciare l'incarico di questa commessa?",
    conferma_presa_in_carico: "Sei sicuro di voler prendere in carico questa commessa?",
    commessa_presa_in_carico: "Commessa presa correttamente in carico!",
    no_utente_in_carico: "Nessun utente ha ancora preso in carico questa commessa",
    prendi_in_carico: "Prendi in carico",
    conferma_svuotamento_tabella: "Sei sicuro di voler svuotare la tabella?",
    svuotamento_tabella: "Svuotamento tabella",
    svuota_tabella: "Svuota tabella",
    codice_otp: "Codice OTP",
    codice_otp_testo: "Inserisci il codice OTP generato dalla tua app di autenticazione.",
    troppi_errori_verifica_codice: "Troppi errori nella verifica del codice, stai per essere riportato alla pagina del login.",
    codice_inserito_errato: "Il codice inserito non è corretto, riprova.",
    prezzo_totale: "Prezzo totale",
    tentativi_rimanenti: "Tentativi rimanenti: ",
    periodo: "Periodo",
    mostra_utenti_selezionati: "Mostra utenti",
    nascondi_utenti_selezionati: "Nascondi utenti",
    crea_copia: "Crea copia",
    ricorda_calcola_prezzi: "Ricorda di calcolare i prezzi se non l'hai ancora fatto!",
    modifica_copia: "Modifica copia",
    totale: "Totale",
    genera_pdf: "Genera PDF",
    desideri_generare_pdf: "Desideri generare il PDF",
    creato_con_successo: "Creato con successo",
    chiudi_righe: "Chiudi righe",
    colonna_bloccata: "Colonna bloccata, non è possibile rimuoverla dalla visualizzazione",
    configurazione_tabella_salvata: "Configurazione tabella salvata",
    errore_salvataggio_configurazione: "Errore durante il salvataggio della configurazione",
    colonne_da_visualizzare: "Colonne da visualizzare",
    sconti: "Sconti",
    mostra_sconti: "Mostra sconti",
    installa_pwa: "Installa app",
    ancora_destra: "Ancora a destra",
    dialog_recuperato: "Finestra recuperata",
    passato_a_dataview: "Passato alla visualizzazione tramite 'Griglia'",
    passato_a_tabs: "Passato alla visualizzazione tramite 'Tabs'",
    ultima_volta_sincronizzati: "Dati sincronizzati l'ultima volta il",
    aggiungi_elemento_creazione: "Aggiungi elemento in creazione",
    centra_dialog: "Centra finestra",
    minimizza: "Minimizza finestra",
    massimizza: "Massimizza finestra",
    minimizza_mobile: "Minimizza",
    massimizza_mobile: "Massimizza",
    mostra_eventi_click: "Mostra eventi al click",
    mostra_eventi_hover: "Mostra eventi al hover",
    riapri_dialog: "Riapri finestra",
    setup_salvato: "Dati del form salvati localmente",
    setup_rimosso: "Dati del form rimossi localmente",
    salva_setup_localmente: "Salva i dati del form localmente (nel browser), in modo da poterli recuperare in futuro",
    elimina_setup_localmente: "Elimina i dati del form salvati localmente",
    ricarica: "Ricarica",
    visualizza_tabs: "Passa alla visualizzazione tramite 'Tabs'",
    visualizza_dataview: "Passa alla visualizzazione tramite 'Griglia'",
    no_dato_trovato: "Nessun dato trovato",
    disancora_elemento: "Disancora elemento",
    sposta_a: "Sposta a",
    destra: "Destra",
    sinistra: "Sinistra",
    eliminazione_dati: "Eliminazione di dati",
    conferma_chiusura_dialog: "Sei sicuro di voler chiudere la finestra?",
    conferma_azione: "Conferma azione",
    categoria_risorsa: "Categoria risorsa",
    duefa: "App di autenticazione",
    password_temporanea: "Password temporanea",
    nessun_elemento_aperto_dialog: "Nessun elemento aperto in questa finestra",
    suggerimenti_dialog_vuota: `Per iniziare, puoi aprire un elemento esistente cliccando sul bottone \'Dettagli\' sulla destra della tabella, oppure crearne uno nuovo usando la Toolbar qui sopra.\nSe in precedenza hai salvato un setup, puoi recuperarlo sempre dalla Toolbar.`,
    setup_non_trovato: "Non hai nessun dato del form salvato localmente",
    setup_ottenuto: "Dati del form ottenuti con successo",
    get_setup: "Ottieni i dati del form salvati",
    avviso: "Avviso",
    avvisi: "Avvisi",
    nessun_avviso: "Nessun avviso",
    nessun_controllo: "Nessun controllo foto",
    segnalazioni: "Segnalazioni",
    nessuna_segnalazione: "Nessuna segnalazione",
    // Richiesta mancata bollatura
    suggerisci_orari: "Suggerisci orari",
    timbrature_proposte_utente: "Timbrature proposte dall'utente",
    timbratura_non_registrata: "Timbratura non registrata",
    suggerisci_orari_istruzioni:
      "Modifica gli orari da correggere o aggiungi le timbrature/pause mancanti, poi invia la richiesta: verrà creata una segnalazione per ogni orario suggerito.",
    aggiungi_timbratura: "Aggiungi timbratura",
    nuova_timbratura: "Nuova timbratura",
    nuova_pausa: "Nuova pausa",
    timbratura: "Timbratura",
    nota_facoltativa: "Nota (facoltativa)",
    invia_richiesta: "Invia richiesta",
    accetta: "Accetta",
    accetta_tutte: "Accetta tutte",
    rifiuta: "Rifiuta",
    approvata: "Approvata",
    rifiutata: "Rifiutata",
    accettata_da_salvare: "Accettata, da salvare",
    orario_suggerito: "Orario suggerito",
    orario_da_richiesta_approvata: "Orario da richiesta approvata",
    suggerimento_non_applicabile:
      "La timbratura di riferimento non esiste più: inserisci l'orario a mano.",
    richiesta_bollatura_inviata: "Richiesta inviata all'amministratore",
    richiesta_bollatura_rifiutata: "Richiesta rifiutata",
    dati_mancanti: "Dati mancanti",
    timbratura_gia_presente:
      "Esiste già una timbratura con questi orari: la richiesta sembra già applicata. Rifiutala se è un doppione.",
    timbratura_nuova_incompleta:
      "Ogni timbratura o pausa aggiunta deve avere sia l'entrata sia l'uscita.",
    tooltip_password_temporanea:
      "La password temporanea sarà disponibile per il login solo una volta: una volta effettuato il primo accesso, l'utente verrà obbligato a cambiarla!",
    creazione_gia_in_corso: "Creazione già in corso!",
    chiudi_elemento: "Chiudi elemento",
    seleziona_file: "Seleziona file",
    importazione_dati: "Importazione di dati",
    importazione_dati_riuscita: "Importazione di dati riuscita!",
    importazione_dati_fallita: "Importazione di dati fallita!",
    importazione_dati_errore: "Errore durante l'importazione dei dati!",
    importazione_in_corso: "Importazione in corso...",
    elementi_importati: "Elementi importati",
    ragione_sociale: "Ragione sociale",
    sigla: "Sigla",
    descma: "Descma",
    cod_fornitore: "Cod. fornitore",
    cod_prodotto: "Cod. prodotto",
    prezzo_netto: "Prezzo netto",
    prezzo_listino: "Prezzo di listino",
    stato_prodotto: "Stato prodotto",
    barcode: "Barcode",
    unita_misura: "Unità di misura",
    serie_vendita: "Serie vendita",
    cod_numerico: "Cod. numerico",
    qta_min_acquistabile: "Qta. min. acquistabile",
    gruppo_1: "Gruppo 1",
    gruppo_2: "Gruppo 2",
    gruppo_3: "Gruppo 3",
    moltipli_prezzo: "Moltipl. prezzo",
    moltipli_prezzo_netto: "Moltipl. prezzo netto",
    iva: "Iva",
    preferiti: "Preferiti",
    dettagli: "Dettagli",
    cvs_headers_errore: "Errore nel file inserito! Headers mancanti",
    desc_serie_vendita: "Descrizione serie vendita",
    data_validita: "Data validità",
    seleziona_righe_pdf: "Seleziona le righe tramite la casella sulla sinistra della tabella da includere nel PDF",
    seleziona_righe_prima: "Per poter archiviare degli elementi, seleziona delle righe tramite la casella sulla sinistra della tabella!",
    seleziona_righe_prima_eliminazione:
      "Per poter eliminare degli elementi, seleziona delle righe tramite la casella sulla sinistra della tabella! L'eliminazione è irreversibile!",
    data_non_valida: "Data non valida",
    prezzo_ora: "Prezzo ora",
    commessa_padre: "Commessa padre",
    alta: "Alta",
    media: "Media",
    bassa: "Bassa",
    priorita: "Priorità",
    dal: "Dal",
    al: "Al",
    no_categoria: "Nessuna categoria",
    note_per_dipendenti: "Note per le dipendenti",
    descrizione_commessa: "Descrizione commessa",
    commessa_principale: "Commessa principale",
    utenti_creatori: "Utenti creatori",
    unione_filtri: "Unione filtri",
    applica_filtri: "Applica filtri",
    filtri: "Filtri",
    oppure: "Oppure",
    e: "E",
    amministratore: "Amministratore",
    se_null_imposta_inizio: "Se lasciato vuoto, verrà automaticamente impostato come un'evento con durata solo un giorno (quello selezionato come inizio)",
    vai_a_profilo: "Vai al profilo",
    commessa_da_pianificare: "La commessa non è ancora stata pianificata.",
    commessa_gia_pianificata: "La commessa è già stata pianificata.",
    pianifica: "Pianifica",
    firma_cliente: "Firma cliente",
    firma_tecnico: "Firma tecnico",
    pulisci: "Pulisci",
    totale_imponibile_iva_esclusa: "Totale imponibile iva esclusa",
    prezzo_orario: "Prezzo orario",
    nessun_prodotto_utilizzato: "Nessun prodotto utilizzato",
    aggiungi_un_prodotto_per_cominciare: "Aggiungi un prodotto per cominciare",
    nessun_risorsa_associata: "Nessuna risorsa associata",
    aggiungi_una_risorsa_per_cominciare: "Aggiungi una risorsa per cominciare",
    ditta_installatrice: "Ditta installatrice",
    prezzo_calcolato: "Prezzo calcolato",
    quantita: "Quantità",
    calcola: "Calcola",
    tipologia_lavoro_svolto: "Tipologia lavoro svolto",
    mostra_prodotti_selezionati: "Mostra prodotti",
    nascondi_prodotti_selezionati: "Nascondi prodotti",
    mostra_dipendenti_selezionate: "Mostra dipendenti",
    nascondi_dipendenti_selezionate: "Nascondi dipendenti",
    sei_sicuro_di_voler_rimuovere_risorsa: "Sei sicuro di voler rimuovere la risorsa",
    si: "SI",
    no: "NO",
    attenzione: "Attenzione",
    campi_obbligatori_mancanti: "Compila i campi obbligatori prima di continuare",
    errore_generico_creazione: "Si è verificato un errore durante il salvataggio. Riprova.",
    mese: "Mese",
    denominazione_cliente: "Denominazione cliente",
    visualizza_firme: "Visualizza firme",
    pdf_rapportino: "PDF rapportino",
    visualizza_rapportino_pdf: "Visualizza PDF rapportino",
    scarica_rapportino_pdf: "Scarica PDF rapportino",
    elimina_rapportino_pdf: "Elimina PDF rapportino",
    generazione_pdf: "Generazione PDF in corso...",
    generazione_pdf_completata: "Generazione PDF completata con successo!",
    programmata: "Programmata",
    in_corso: "In corso",
    completata: "Completata",
    info_commesse_pianificazione: "INFO COMMESSE",
    modifica_creazione: "Creazione e Modifica",
    visualizza_commesse: "Visualizzazione Commesse",
    step_commesse: "Step delle Commesse",
    pianificazione_commesse: "Pianificazione Commesse",
    descrizione_modifica_creazione: "Qui puoi creare nuove commesse e modificarle facilmente.",
    descrizione_visualizzazione: "Accedi alla lista delle commesse per una panoramica completa.",
    descrizione_step: " Ogni commessa è suddivisa in vari step che possono essere monitorati.",
    conferma_pianifica: "Vuoi pianificare la commessa appena creata?",
    descrizione_pianificazione:
      "La pianificazione di una commessa consiste nella organizzazione di tutte le attività necessarie per completarla in modo efficiente.",
    mostra_commesse: "Mostra",
    funzionamento_filtri: "Funzionamento filtri",
    recupera_password: "Recupera password",
    inserisci_Username: "Inserisci lo username",
    inserisci_Username_per_recupero_passoword: `Inserisci il tuo username per effettuare la richiesta di recupero della password`,
    verifica_il_codice: "Verifica il codice",
    codice_tramite_email: `Inserisci il codice che ti è stato inviato tramite e-mail`,
    resetta_password: "Resetta la password",
    generatore_password: `Utilizza il generatore per creare una password robusta e sicura. Riceverai un'e-mail con la nuova password.`,
    torna_al_login: "Torna al login",
    dash_presenti_oggi: "Presenti oggi",
    dash_vai_a_calendario: "Vai a calendario",
    dash_ritardi: "Ritardi",
    dash_media_ritardo: "Media ritardo",
    dash_ore_lavorate: "Ore lavorate",
    dash_permessi_kpi: "Permessi",
    dash_tasso_assenza: "Tasso assenza",
    dash_alto: "Alto",
    dash_basso: "Basso",
    dash_gg: "gg",
    dash_oggi: "Oggi",
    dash_giorno: "Giorno",
    dash_settimana: "Settimana",
    dash_mese: "Mese",
    dash_risorsa: "Risorsa",
    dash_altro: "Altro",
    dash_stato_team_oggi: "Stato del team oggi",
    dash_presenti_label: "presenti",
    dash_presenti: "Presenti",
    dash_assenti: "Assenti",
    dash_in_permesso: "In permesso",
    dash_in_ritardo: "In ritardo",
    dash_nessun_presente: "Nessun presente",
    dash_tutti_presenti: "Tutti presenti",
    dash_nessun_permesso_oggi: "Nessun permesso oggi",
    dash_andamento_classifiche: "Andamento & Classifiche",
    dash_puntualita: "Puntualità",
    dash_presenze: "Presenze",
    dash_nessuna_assenza: "Nessuna assenza registrata",
    dash_attenzioni_amministrative: "Avvisi amministrativi",
    dash_nessuna_attenzione: "Nessun avviso presente",
    dash_non_bloccato: "Non bloccato",
    dash_note: "Note",
    dash_nessuna_bacheca: "Nessun dato presente in bacheca",
    dash_senza_titolo: "Senza titolo",
    dash_alta: "Alta",
    dash_media: "Media",
    dash_bassa: "Bassa",
    dash_referente: "Referente",
    dash_tour_menu_title: "Menu",
    dash_tour_menu_desc: "Mostra o nasconde il menu laterale.",
    dash_tour_fav_title: "Aggiungi ai preferiti",
    dash_tour_fav_desc: "Aggiungi o rimuovi questa pagina dai preferiti.",
    dash_tour_theme_title: "Cambia tema",
    azioni_rapide: "Azioni rapide",
    dash_tour_theme_desc: "Cambia il tema dell'interfaccia (chiaro, scuro o automatico).",
    dash_tour_quick_actions_title: "Azioni rapide",
    dash_tour_quick_actions_desc: "Scorciatoie per accedere rapidamente alle pagine più utilizzate. Puoi riordinarle con il pulsante in alto a destra.",
    dash_sa_m2_title: "Dashboard Super Admin",
    dash_sa_m2_subtitle: "Panoramica multi-azienda in tempo reale",
    dash_sa_m2_placeholder: "Panoramica multi-azienda in arrivo. Qui vedrai licenze, utenti, timbrature e impostazioni di ciascuna azienda gestita.",
    dash_sa_aziende_totali: "Aziende",
    dash_sa_utenti_totali: "Utenti attivi",
    dash_sa_bollature_24h: "Bollature 24h",
    dash_sa_bollature_7gg: "Bollature 7gg",
    dash_sa_utenti_licenza: "Utenti / licenza",
    dash_sa_ruoli: "Utenti per ruolo",
    dash_sa_ruolo_sa: "Super Admin",
    dash_sa_ruolo_admin: "Admin",
    dash_sa_ruolo_risorsa: "Risorse",
    dash_sa_impostazioni: "Impostazioni attive",
    dash_sa_rinnovo: "Rinnovo",
    dash_sa_licenza_nd: "Licenza n/d",
    dash_sa_dettagli_azienda: "Dettagli azienda",
    dash_sa_anagrafica: "Anagrafica",
    dash_sa_codice_univoco: "Codice univoco",
    dash_sa_ragione_sociale: "Ragione sociale",
    dash_sa_licenza: "Licenza",
    dash_sa_prossimo_rinnovo: "Prossimo rinnovo",
    dash_sa_partita_iva: "Partita IVA",
    dash_sa_codice_fiscale: "Codice fiscale",
    dash_sa_indirizzo: "Indirizzo",
    dash_sa_telefono: "Telefono",
    dash_sa_email: "Email",
    dash_sa_pec: "PEC",
    dash_sa_referente: "Referente",
    dash_sa_data_creazione: "Data creazione",
    dash_sa_utenti_lista: "Utenti azienda",
    dash_sa_ultima_bollatura: "Ultima bollatura",
    dash_sa_ultimo_login: "Ultimo login",
    dash_sa_accesso_abilitato: "Abilitato",
    dash_sa_accesso_disabilitato: "Disabilitato",
    dash_sa_nessun_utente: "Nessun utente",
    nessun_risultato: "Nessun risultato",
    dash_qr_timbra_title: "Il tuo QR Code",
    dash_qr_timbra_desc: "Mostra questo QR al kiosk o alla fotocamera per timbrare rapidamente.",
    dash_pin_timbra_title: "Il tuo PIN di timbratura",
    dash_pin_timbra_desc: "In alternativa al QR, premi \"Usa il PIN\" sul kiosk e digita questo codice. Non condividerlo.",
    pin_timbratura_title: "PIN di timbratura",
    pin_timbratura_desc: "Codice univoco usato dal kiosk per la timbratura manuale. Non condividerlo.",
    mostra_pin: "Mostra PIN",
    nascondi_pin: "Nascondi PIN",
    invia_pin_email: "Invia PIN via email",
    pin_email_inviato: "PIN inviato via email all'utente.",
    pin_email_non_presente: "L'utente non ha un indirizzo email.",
    pin_non_valido: "PIN non valido",
    dash_qa_title: "Azioni rapide",
    dash_qa_reorder: "Riordina",
    dash_qa_save_order: "Salva ordine",
    dash_qa_cancel_reorder: "Annulla",
    dash_qa_order_saved: "Ordine salvato con successo",
    dash_qa_archivio_documenti: "Archivio documenti",
    dash_qa_archivio_documenti_desc: "Consulta e gestisci i documenti archiviati del personale",
    dash_qa_resoconto_presenze: "Resoconto presenze",
    dash_qa_resoconto_presenze_desc: "Consulta i report giornalieri e mensili delle presenze",
    dash_qa_risorse: "Gestione risorse",
    dash_qa_risorse_desc: "Anagrafica dipendenti, ruoli e configurazioni personali",
    dash_qa_turni: "Pianificazione turni",
    dash_qa_turni_desc: "Organizza e assegna i turni di lavoro del team",
    dash_qa_resoconto_permessi: "Resoconto permessi",
    dash_qa_resoconto_permessi_desc: "Riepilogo ferie, permessi e malattie per periodo",
    dash_qa_bacheca: "Bacheca",
    dash_qa_bacheca_desc: "Pubblica comunicazioni e avvisi per il personale",
    dash_qa_note_spese: "Note spese",
    dash_qa_note_spese_desc: "Visualizza e approva le note spese dei dipendenti",
    dash_qa_impostazioni: "Impostazioni",
    dash_qa_impostazioni_desc: "Configura orari e parametri generali",
    dash_qa_checkin_remoto: "Check-in remoto",
    dash_qa_checkin_remoto_desc: "Timbra entrata e uscita da remoto",

    // Quick actions — dashboard risorsa (dipendente)
    dash_qar_archivio_documenti: "I miei documenti",
    dash_qar_archivio_documenti_desc: "Consulta i tuoi documenti personali",
    dash_qar_resoconto_presenze: "Le mie presenze",
    dash_qar_resoconto_presenze_desc: "Visualizza il riepilogo delle tue presenze",
    dash_qar_resoconto_permessi: "Ferie e permessi",
    dash_qar_resoconto_permessi_desc: "Controlla le tue ferie, permessi e assenze",
    dash_qar_note_spese: "Le mie note spese",
    dash_qar_note_spese_desc: "Inserisci e consulta le tue note spese",
    dash_qar_checkin_remoto: "Check-in remoto",
    dash_qar_checkin_remoto_desc: "Timbra la tua entrata e uscita da remoto",

    dash_qa_giorni_fine_mese: "Mancano {days} giorni alla fine del mese",
    dash_qa_ultimo_giorno_mese: "Oggi è l'ultimo giorno del mese",
    dash_tour_calendar_title: "Calendario",
    dash_tour_calendar_desc: "Visualizza gli eventi del team. Puoi cambiare vista tra giorno, settimana e mese.",
    dash_tour_team_title: "Stato del team",
    dash_tour_team_desc: "Visualizza lo stato attuale del team: presenti, assenti, in permesso e in ritardo.",
    dash_richieste_da_approvare: "Richieste da approvare",
    dash_le_mie_richieste: "Le mie richieste",
    dash_richieste_gruppo: "Richieste gruppo",
    dash_prossime_assenze: "Prossime assenze",
    dash_il_mio_turno: "Il mio turno",
    dash_turno_giorno_precedente: "Giorno precedente",
    dash_turno_giorno_successivo: "Giorno successivo",
    dash_turno_riposo: "Nessun turno previsto",
    dash_turno_facoltativo: "Facoltativo",
    dash_turno_notturno: "Turno notturno: termina il giorno successivo",
    dash_turno_pausa: "Pausa",
    dash_turno_pausa_retribuita: "retribuita",
    ieri: "Ieri",
    domani: "Domani",
    dash_nessuna_assenza_futura: "Nessuna assenza programmata",
    dash_nessuna_richiesta_futura: "Nessuna richiesta futura",
    dash_nessuna_nota_spese: "Nessuna nota spese nel periodo",
    dash_stato_approvato: "Approvato",
    dash_stato_in_attesa: "In attesa",
    dash_stato_rifiutato: "Rifiutato",
    dash_ferie_permessi: "Ferie e permessi",
    dash_note_spese: "Note spese",
    dash_nessuna_richiesta_permesso: "Nessuna richiesta di permesso in attesa",
    dash_nessuna_richiesta_rimborso: "Nessuna nota spese in attesa",
    dash_dettagli: "Dettagli",
    dash_richiesto_il: "Richiesto il",
    dash_tasso_presenza: "Tasso presenza",
    dash_richieste_aperte: "Richieste aperte",
    dash_ferie_residue_media: "Ferie residue (media)",
    dash_ferie_godute: "Ferie godute",
    dash_ore_straordinario: "Straordinari",
    dash_mesi_da_chiudere: "Mesi da chiudere",
    dash_panoramica_mensile: "Panoramica mensile",
    dash_distribuzione_assenze: "Distribuzione assenze",
    dash_trend_presenze: "Trend settimanale",
    dash_urgente: "Urgente",
    dash_mostra_tutti: "Mostra tutti",
    dash_tutti_mesi_ok: "Tutti i mesi sono bloccati correttamente",
    dash_vai_a_risorsa: "Apri scheda",
    dash_con_eventi: "Con eventi",
    dash_tutte_risorse: "Tutte",
    dash_mesi_non_bloccati: "Mesi non bloccati",
    dash_mesi_con_note: "Mesi con note",
    dash_ultime_timbrature: "Timbrature oggi",
    dash_nessuna_timbratura: "Nessuna timbratura registrata oggi",
    dash_entrata: "Entrata",
    dash_uscita: "Uscita",
    le_mie_dimenticanze: "Le mie segnalazioni",
    nuova_dimenticanza: "Nuova segnalazione",
    nessuna_dimenticanza: "Nessuna segnalazione trovata",
    descrivi_dimenticanza: "Descrivi la segnalazione da inviare all'amministrazione...",
    dimenticanza_creata: "Segnalazione inviata con successo",
    dimenticanza_eliminata: "Segnalazione eliminata",
    dimenticanza_modificata: "Segnalazione modificata con successo",
    modifica_dimenticanza: "Modifica segnalazione",
    conferma_eliminazione_dimenticanza: "Sei sicuro di voler eliminare questa segnalazione?",
    resoconto_dimenticanze: "Resoconto segnalazioni",
    nota_admin: "Nota amministrazione",
    modifica_nota: "Modifica nota",
    modifica_nota_admin: "Modifica nota amministrazione",
    scrivi_nota_admin: "Scrivi una nota per la risorsa...",
    nota_admin_salvata: "Nota amministrazione salvata",
    rispondi: "Rispondi",
    da_compilare: "Da compilare",
    in_attesa: "In attesa di validazione",
    filtra_per_data: "Filtra per data",
    rimuovi_filtro: "Rimuovi filtro",
    mese_precedente: "Mese precedente",
    mese_successivo: "Mese successivo",
    vai_a_mese_corrente: "Vai al mese corrente",
    con_nota: "Con nota",
    senza_nota: "Senza nota",
    nessuna_nota_spese: "Nessuna nota spese",

    // --- Gruppi / Amministratori: testi sezione orari e form ---
    notifica_anche_capogruppo: "Notifica anche il capogruppo designato",
    notifica_solo_capogruppo: "Notifica solo il capogruppo designato",
    spiegazione_notifica_anche_capogruppo:
      "Notifica anche il capogruppo designato quando un utente del gruppo invia una nuova richiesta di permesso o ferie. Se selezionato, il capogruppo designato riceverà le stesse notifiche relative a ferie, permessi e rimborsi spese dei membri del gruppo che riceveranno gli indirizzi mail configurate nelle impostazioni aziendali.",
    spiegazione_notifica_solo_capogruppo:
      "Notifica solo il capogruppo designato quando un utente del gruppo invia una nuova richiesta di permesso o ferie. Se selezionato, il capogruppo designato sarà l'unico a ricevere le notifiche relative a ferie, permessi e rimborsi spese dei membri del gruppo, andando ad escludere gli indirizzi mail configurati nelle impostazioni aziendali.",
    solo_impostazioni: "Solo emails nelle impostazioni",
    sia_capogruppo_che_impostazioni: "Sia capogruppo che emails nelle impostazioni",
    solo_capogruppo: "Solo capogruppo",
    nessuno: "Nessuno",
    colore_identificativo_gruppo: "Colore identificativo del gruppo",
    clicca_per_rimuovere: "Premi qui per rimuovere il capogruppo.",
    capogruppo_esterno_al_gruppo: "Capogruppo esterno al gruppo",
    spiegazione_capogruppo_esterno_al_gruppo:
      "È possibile selezionare un capogruppo esterno al gruppo, che avrà visibilità sulle ferie, permessi e rimborsi spese dei membri del gruppo, e riceverà le relative notifiche. Questa opzione è utile se si desidera che un responsabile o un supervisore abbia accesso alle informazioni del gruppo senza essere formalmente parte di esso.",
    colore_selezionato: "Colore",
    gruppi_dati_anagrafici_descrizione: "Inserisci il nome del gruppo, scegli un colore identificativo e associa il gruppo all'azienda di riferimento.",
    gruppi_utenti_descrizione:
      "Seleziona gli utenti da includere in questo gruppo. Puoi designare solamente un utente come capogruppo: sarà abilitato alla visualizzazione di ferie / permessi e rimborse spese dei membri del gruppo. Se configurato, riceverà anche le notifiche inerenti a ferie, permessi e rimborsi spese dei membri del gruppo.",
    rimuovi_dal_gruppo: "Rimuovi dal gruppo",
    aggiungi_membri_gruppo: "Membri del gruppo",
    aggiungi_membri_gruppo_hint: "Cerca e seleziona gli utenti da includere nel gruppo",
    nessun_membro_nel_gruppo: "Nessun membro aggiunto",
    nessun_membro_nel_gruppo_hint: "Utilizza il selettore in alto per aggiungere utenti al gruppo",
    visualizza_ferie_permessi: "Vedi ferie/permessi",
    spiegazione_visualizza_ferie_permessi: "Consente all'utente di visualizzare le richieste di ferie e permessi dei membri del gruppo",
    visualizza_note_spese: "Vedi note spese",
    spiegazione_visualizza_note_spese: "Consente all'utente di visualizzare le richieste di rimborso spese dei membri del gruppo",
    accetta_rifiuta_ferie_permessi: "Gestisci ferie/permessi",
    spiegazione_accetta_rifiuta_ferie_permessi: "Consente all'utente di approvare o rifiutare le richieste di ferie e permessi dei membri del gruppo",
    accetta_rifiuta_note_spese: "Gestisci note spese",
    spiegazione_accetta_rifiuta_note_spese: "Consente all'utente di approvare o rifiutare le richieste di rimborso spese dei membri del gruppo",
    seleziona_capogruppo_esterno: "Seleziona un capogruppo esterno...",
    accesso_non_abilitato: "Accesso non abilitato",
    permessi_capogruppo_esterno: "Permessi capogruppo esterno",
    capogruppo_esterno_bloccato: "Per selezionare un capogruppo esterno è necessario prima rimuovere il capogruppo interno designato",
    gruppi_impostazioni_descrizione:
      "Configura le funzionalità operative disponibili per gli utenti di questo gruppo. Le modifiche si applicano a tutti i membri.",
    bollatura_attiva_descrizione: "Permette agli utenti del gruppo di timbrare le presenze tramite il sistema di rilevazione.",
    bollatura_remota_descrizione: "Abilita la timbratura da postazioni o dispositivi remoti, come app mobile o totem esterni.",
    banca_ore_descrizione:
      "Attiva la gestione del saldo ore: tiene traccia delle ore accumulate o mancanti rispetto all'orario contrattuale. Il saldo viene aggiornato automaticamente a fine giornata.",
    impostazioni_notifiche_descrizione:
      "Definisci quali eventi generano notifiche verso i responsabili e i capogruppo. Le notifiche vengono inviate via email.",
    permessi_e_ferie: "Permessi e Ferie",
    notifica_permesso_nuovo_descrizione: "Notifica quando un utente del gruppo invia una nuova richiesta di permesso o ferie.",
    notifica_permesso_modificato_descrizione: "Notifica quando una richiesta di permesso o ferie già inviata viene aggiornata dall'utente.",
    rimborsi_spese: "Rimborsi Spese",
    notifica_rimborso_nuova_descrizione: "Notifica alla ricezione di una nuova richiesta di rimborso spese da parte di un utente del gruppo.",
    notifica_rimborso_aggiornata_descrizione: "Notifica quando una richiesta di rimborso spese già inviata viene modificata o aggiornata.",
    modalita_orario: "Modalità orario",
    modalita_ordinari_titolo: "Ordinari",
    modalita_ordinari_desc: "Ingresso/uscita fissi con fasce orarie e pause",
    modalita_flessibili_titolo: "Flessibili",
    modalita_flessibili_desc: "Range ingresso, uscita e pausa con min/max",
    modalita_liberi_titolo: "Liberi",
    modalita_liberi_desc: "Solo ore lavorative e limiti di pausa",
    modalita_turni_titolo: "Turni",
    modalita_turni_desc: "Abilita la configurazione di settimane con orari diversi a rotazione",
    modalita_ordinari_info:
      "Configura gli orari ordinari per ogni giorno della settimana. I dipendenti dovranno timbrare ingresso e uscita entro le fasce orarie indicate, e rispettare le pause configurate.",
    modalita_flessibili_info: "Per ogni giorno definisci un range di ingresso, uno di uscita, uno per la pausa, e i limiti min/max di durata pausa.",
    modalita_liberi_info: "L'utente può timbrare liberamente. Imposta le ore lavorative richieste e i limiti di pausa minima e massima.",
    modalita_turni_info:
      "Ora l'anagrafica è abilitata nella pagina per la pianificazione dei turni. Puoi configurare i turni di lavoro di questa anagrafica direttamente dalla apposita sezione.",
    nessuna_modalita_orario: "Nessuna modalità orario abilitata per questa azienda.",
    nessuna_modalita_orario_hint: "Configura le modalità nelle impostazioni azienda.",
    seleziona_modalita_orario: "Seleziona una modalità orario",
    fasce_orarie: "Fasce orarie",
    aggiungi_fascia: "Aggiungi fascia",
    turno_numero: "Turno",
    rimuovi_turno: "Rimuovi turno",
    aggiungi_pausa: "Aggiungi pausa",
    pausa_numero: "Pausa",
    inizio_pausa: "Inizio pausa",
    fine_pausa: "Fine pausa",
    nessuna_fascia_oraria: "Nessuna fascia oraria configurata",
    ingresso_consentito: "Ingresso consentito",
    uscita_consentita: "Uscita consentita",
    finestra_pausa: "Finestra pausa",
    durata_pausa: "Durata pausa",
    dalle: "Dalle",
    alle: "Alle",
    minimo: "Minimo",
    massimo: "Massimo",
    pausa_minima: "Pausa minima",
    pausa_massima: "Pausa massima",

    // --- Amministratori: sezioni step form ---
    credenziali_accesso_titolo: "Credenziali di accesso",
    credenziali_accesso_descrizione: "Definisci le credenziali per accedere al sistema",
    accesso_al_sistema: "Accesso al sistema",
    accesso_abilitato: "Accesso abilitato",
    accesso_disabilitato: "Accesso disabilitato per questo utente",
    azienda_non_attiva: "Accesso non disponibile: il servizio per la tua azienda non è attivo. Contatta il tuo referente.",
    tabella_non_ammessa: "Operazione non consentita su questi dati.",
    accesso_al_sistema_descrizione: "Scegli se questo utente potrà autenticarsi al sistema",
    abilitato: "Abilitato",
    disabilitato: "Disabilitato",
    accesso_consentito: "Accesso consentito",
    accesso_consentito_descrizione: "L'utente potrà effettuare il login con le credenziali assegnate",
    accesso_non_consentito: "Accesso non consentito",
    accesso_non_consentito_descrizione: "L'utente sarà registrato ma non potrà autenticarsi",
    hint_accesso_abilitato: "L'utente riceverà credenziali di accesso. Sono richiesti una password valida e un indirizzo email.",
    hint_accesso_disabilitato: "Verrà creata solo l'anagrafica: password ed email non sono obbligatorie. Potrai abilitare l'accesso in un secondo momento.",
    requisiti_password_info: "La password deve contenere almeno 12 caratteri, una lettera maiuscola, una minuscola, un numero e un carattere speciale.",
    affidabilita_alta: "Alta",
    affidabilita_media: "Media",
    affidabilita_bassa: "Bassa",
    sezione_identita: "Identità",
    sezione_dati_personali: "Dati personali",
    sezione_nascita: "Nascita",
    sezione_contatti: "Contatti",
    domicilio_residenza_titolo: "Domicilio / Residenza",
    domicilio_residenza_descrizione: "Inserisci l'indirizzo di residenza o domicilio",
    sezione_indirizzo: "Indirizzo",
    sezione_dettagli_localita: "Dettagli località",
    dati_fondo_pensione: "Dati fondo pensione",
    tfr_in_azienda_desc: "TFR trattenuto in azienda",
    tfr_fondo_esterno_desc: "TFR versato a un fondo pensione",
    nessun_dato_tfr: "Nessun dato TFR associato",

    // --- Preset turni ---
    preset_turni: "Preset turni",
    crea_preset_turno: "Crea preset turno",
    modifica_preset_turno: "Modifica preset turno",
    nome_preset_placeholder: "Es. Turno mattina",
    descrizione_opzionale: "Descrizione (opzionale)",
    nessun_preset: "Nessun preset configurato",
    preset_creato_successo: "Preset turno creato con successo",
    preset_aggiornato_successo: "Preset turno aggiornato con successo",
    preset_eliminato_successo: "Preset eliminato con successo",
    compila_campi_obbligatori: "Compila i campi obbligatori",
    salvataggio_non_riuscito: "Salvataggio non riuscito",
    eliminazione_non_riuscita: "Eliminazione non riuscita",
    preset_non_trovato: "Preset non trovato",
    configura_giorni_preset_info:
      "Per ogni giorno della settimana, abilitalo e configura una o più fasce orarie. Per ogni fascia indica orario di inizio, di fine, se le pause sono retribuite e l'eventuale lista di pause.",
    fascia_numero: "Fascia",
    inizio: "Inizio",
    fine: "Fine",
    pause_retribuite: "Pause retribuite",
    pause: "Pause",
    pausa_numero: "Pausa",
    pausa_con_orari: "Con orari",
    pausa_libera: "Libera",
    pausa_libera_info: "La pausa potrà essere effettuata in qualsiasi momento",
    durata_pausa: "Durata pausa",
    fascia_label: "fascia",
    fasce_label: "fasce",
    salvato: "Salvato",
    vedi_preset: "Vedi Preset",
    prossima_settimana: "Prossima settimana",
    settimana_passata_sola_lettura: "Settimana passata — sola lettura",
    turno_associato: "Turno associato",
    seleziona_preset: "Seleziona preset turno",
    turni_rotazione_non_attiva: "Rotazione turni non attiva",
    assegnazione_salvata: "Assegnazione salvata",
    assegnazioni_salvate: "Assegnazioni salvate",
    modifiche_non_salvate: "Modifiche non salvate",
    salva_modifiche: "Salva modifiche",
    visualizza_preset: "Visualizza preset",
    dettaglio_preset: "Dettaglio Preset",
    preset_non_trovato: "Preset non trovato",
    eccezioni: "Eccezioni",
    eccezioni_giornaliere: "Eccezioni giornaliere",
    gestisci_eccezioni: "Gestisci eccezioni giornaliere",
    stesso_preset_settimanale: "Stesso preset settimanale",
    salva_eccezioni: "Salva eccezioni",
    eccezioni_salvate: "Eccezioni salvate",
    eccezione_rimossa: "Eccezione rimossa",
    rimuovi_eccezione: "Rimuovi eccezione",
    errore_salvataggio_eccezioni: "Errore nel salvataggio delle eccezioni",
    nessuna_eccezione_short: "Nessuna",
    preset: "Preset",
    personalizzato: "Personalizzato",
    con_orari: "Con orari",
    pausa: "Pausa",
    giorno_precedente: "giorno precedente",
    prospetto_dipendente: "Prospetto dipendente",
    proiezione_saldi: "Proiezione saldi",
    orizzonte_temporale: "Orizzonte temporale",
    mesi_1: "1 mese",
    mesi_3: "3 mesi",
    mesi_6: "6 mesi",
    mesi_12: "12 mesi",
    saldo_ferie: "Saldo ferie",
    saldo_permessi: "Saldo permessi",
    saldo_banca_ore: "Saldo banca ore",
    apertura: "Apertura",
    chiusura: "Chiusura",
    accrediti: "Accrediti",
    addebiti: "Addebiti",
    riepilogo: "Riepilogo",
    proiezione: "Proiezione",
    dettaglio_mensile: "Dettaglio mensile",
    storico_transazioni: "Storico transazioni",
    confronto_prima_dopo: "Confronto prima/dopo approvazione",
    prima: "Prima",
    dopo: "Dopo",
    richieste_pendenti: "Richieste pendenti",
    nessuna_richiesta_pendente: "Nessuna richiesta pendente nel periodo",
    allerta_saldo_negativo: "Saldo {tipo} negativo previsto a {mese}",
    allerta_superamento_massimo: "Saldo {tipo} al tetto massimo a {mese}",
    ore: "Ore",
    mese: "Mese",
    caricamento_prospetto: "Caricamento prospetto...",
    errore_caricamento_prospetto: "Errore nel caricamento del prospetto",
    richiesta_corrente: "Richiesta corrente",
    incremento_periodico: "Incremento periodico",
    tetto_massimo: "Tetto massimo",
    non_configurato: "Non configurato",
    saldi_attuali: "Saldi attuali",
    configurazione_incrementi: "Configurazione incrementi",
    categoria: "Categoria",
    tipo_impatto: "Tipo impatto",
    dati_bollatura_non_configurati: "Dati bollatura non configurati per questo dipendente",
    prospetto_aziendale: "Prospetto aziendale",
    saldi_proiettati: "Saldi proiettati",
    dipendente: "Dipendente",
    nessun_alert: "Nessun alert",
    apri_prospetto_completo: "Apri prospetto completo",
    errore_caricamento_prospetto_aziendale: "Errore nel caricamento del prospetto aziendale",
    nessun_dipendente_trovato: "Nessun dipendente trovato",
    attuale: "Attuale",
    proiettato: "Proiettato",
    disponibile_reale: "Disponibile reale",
    impegnato_futuro: "Impegnato futuro",
    ore_in_attesa: "In attesa di approvazione",
    saldo_attuale_label: "Saldo attuale",
    saldo_proiettato_label: "Saldo proiettato",
    proiezione_mensile: "Proiezione mensile",
    cronologia_transazioni: "Cronologia transazioni",
    tipo_saldo: "Tipo saldo",
    da_data: "Dal",
    a_data: "Al",
    azzera_filtri: "Azzera filtri",
    saldo_dopo: "Saldo dopo",
    saldo_prima: "Saldo prima",
    fonte_scarico: "Fonte",
    assenze_che_impattano: "Assenze che impattano {mese}",
    movimento: "Movimento",
    operatore: "Operatore",
    tutti: "Tutti",
    fine_mese_prec: "Fine mese prec.",
    inizio_mese: "Inizio mese",
    fine_mese: "Fine mese",
    inizio_mese_succ: "Inizio mese succ.",
    maturazione: "Maturazione",
    assenze: "Assenze",
    saldi_del_mese: "Saldi del mese",
    uscita_anticipata: "Uscita anticipata",
    pausa_non_timbrata: "Pausa non timbrata",
    pausa_sotto_minima: "Pausa sotto il minimo consentito",
    pausa_oltre_massima: "Pausa oltre il massimo consentito",
    // Profilo → Privacy e dati, richiesta di eliminazione dell'account (cestino, pagina /elimina-account)
    privacy_e_dati: "Privacy e dati",
    richiedi_eliminazione_account: "Richiedi eliminazione dell'account",
    richiesta_eliminazione_spiegazione:
      "La richiesta arriva all'amministratore della tua azienda. I dati di presenza restano conservati per obbligo di legge; gli accessi ai tuoi dispositivi vengono revocati subito.",
    scarica_i_miei_dati: "Scarica i miei dati",
    richiesta_eliminazione_inviata: "Richiesta di eliminazione inviata: la sessione è stata chiusa",
    richieste_eliminazione: "Richieste di eliminazione",
    segna_come_gestita: "Segna come gestita",
    elimina_account_titolo: "Eliminazione dell'account",
    elimina_account_intro: "L'account Todo-E lo crea l'azienda per cui lavori. Puoi chiederne l'eliminazione in due modi.",
    elimina_account_dal_profilo: "Dall'app: accedi, apri il tuo profilo, sezione «{sezione}», e premi «{pulsante}».",
    elimina_account_via_email: "Senza accedere: scrivi a {email} dall'indirizzo email del tuo account, indicando nome, cognome e azienda.",
    // Resoconto sul telefono (spec 2026-10-26-resoconto-telefono-design)
    tutti_i_giorni: "Tutti i giorni",
    da_verificare: "Da verificare",
    nessun_giorno_da_verificare: "Nessun giorno da verificare in {mese}.",
    totale_ore_lavorate: "Totale ore lavorate",
    ore_speciali_breve: "Ore speciali",
    riepiloghi: "Riepiloghi",
    riepiloghi_di: "Riepiloghi di {mese}",
    mostra_solo_giorni_da_verificare: "Mostra solo i giorni da verificare",
    anno_precedente: "Anno precedente",
    anno_successivo: "Anno successivo",
    cerca_per_nome: "Cerca per nome",
    nessun_dipendente_tutta_azienda: "Nessun dipendente (tutta l'azienda)",
    etichetta_straordinario: "Straord. {ore}",
    etichetta_permesso: "Permesso {ore}",
    etichetta_ferie: "Ferie {ore}",
    etichetta_malattia: "Malattia {ore}",
    etichetta_avvisi: "Avvisi: {n}",
    segnalazioni_in_attesa: "{n} in attesa di risposta",
    nessuna_timbratura: "Nessuna",
    previsto_orari: "Previsto {orari}",
    turno_previsto: "Turno previsto",
  },
  en: {},
  fr: {},
};
